import { RESOURCE_ENDPOINTS } from './resource'

export default {
  MENUS: [
    {
      title: 'Tổ chức',
      name: 'Organizations',
      type: 'organizations',
      icon: 'fas fa-users-cog',
      show: true,
      apiEndpoints: [
        RESOURCE_ENDPOINTS.ORGANIZATIONS,
        RESOURCE_ENDPOINTS.ORGANIZATION_ACTIONS,
        RESOURCE_ENDPOINTS.ORGANIZATION_ACTION_ASSIGNEES,
        RESOURCE_ENDPOINTS.ORGANIZATIONS_ADD_ADMIN,
        RESOURCE_ENDPOINTS.ORGANIZATIONS_ADD_MEMBER,
        RESOURCE_ENDPOINTS.ORGANIZATIONS_ADD_OWNER,
        RESOURCE_ENDPOINTS.ORGANIZATIONS_APPOINT_OWNER,
        RESOURCE_ENDPOINTS.ORGANIZATIONS_REMOVE_MEMBER
      ]
    },
    {
      title: 'Google Analytics',
      name: 'GGAnalytics',
      type: 'gg-analytics',
      icon: 'fas fa-chart-bar',
      apiEndpoints: [
        RESOURCE_ENDPOINTS.ANALYTICS
      ],
      show: false
    },
    {
      title: 'Dashboard',
      name: 'Home',
      type: 'home',
      icon: 'fas fa-tachometer-alt',
      apiEndpoints: [
        RESOURCE_ENDPOINTS.RECORD_UTILS_COUNT,
        RESOURCE_ENDPOINTS.RECEIPT,
        RESOURCE_ENDPOINTS.RECEIPT_STATISTIC
      ],
      show: false
    },
    {
      title: 'Đất nước',
      view: 'shared',
      name: 'Country',
      type: 'country',
      icon: 'fas fa-globe',
      apiEndpoints: [
        RESOURCE_ENDPOINTS.PLACE,
        RESOURCE_ENDPOINTS.PLACE_ENABLE,
        RESOURCE_ENDPOINTS.PLACE_LIST,
        RESOURCE_ENDPOINTS.PLACE_RATINGS,
        RESOURCE_ENDPOINTS.GROUP,
        RESOURCE_ENDPOINTS.GROUP_ITEM,
        RESOURCE_ENDPOINTS.PLACE_CATEGORIES,
        RESOURCE_ENDPOINTS.STORAGE,
        RESOURCE_ENDPOINTS.STORAGE_LIST
      ],
      index: {
        titles: [{ label: 'ĐẤT NƯỚC', value: 'country' }],
        columns: ['stt', 'avatar', 'name', 'star', 'rating', 'view_count', 'created_at', 'updated_at', 'language', 'actions'],
        actions: ['public', 'private', 'edit', 'detail', 'booking', 'delete'],
        headerActions: ['add', 'filter', 'reset', 'synchronize', 'import', 'export'],
        excelColumns: ['id', 'name', 'ordered', 'vrtour', 'description', 'content', 'vehicle_info_desc', 'vehicle_info', 'local_cuisine_desc', 'local_cuisine', 'travel_experience_desc', 'travel_experience', 'festival_info_desc', 'festival_info', 'fun_facts_desc', 'fun_facts', 'status', 'category_id', 'location_address', 'location_longitude', 'location_latitude', 'youtube_links']
      },
      show: {
        inputs: ['name', 'ordered', 'vrtour', 'vrtour_trailer', 'description', 'content', 'vehicle_info', 'local_cuisine', 'travel_experience', 'festival_info', 'fun_facts'],
        leftCards: ['rating', 'groups'],
        rightCards: [
          'display',
          'category',
          'address',
          'youtube',
          'audios',
          'documents',
          'pictures',
          'videos'
        ]
      },
      detail: [
        'area',
        'dashboard',
        'kiosk',
        'lookup',
        'attraction',
        'museum',
        'event',
        'stay',
        'cuisine',
        'entertainment',
        'company',
        'health',
        'real-estate',
        'government-agency',
        'financial',
        'golf',
        'restaurant',
        'craft-village',
        'travel-experience',
        'other',
        'campaign',
        'tour'
      ]
    },
    {
      title: 'Khu vực',
      view: 'shared',
      name: 'Area',
      type: 'area',
      icon: 'fas fa-city',
      apiEndpoints: [
        RESOURCE_ENDPOINTS.PLACE,
        RESOURCE_ENDPOINTS.PLACE_ENABLE,
        RESOURCE_ENDPOINTS.PLACE_LIST,
        RESOURCE_ENDPOINTS.PLACE_RATINGS,
        RESOURCE_ENDPOINTS.GROUP,
        RESOURCE_ENDPOINTS.GROUP_ITEM,
        RESOURCE_ENDPOINTS.PLACE_CATEGORIES,
        RESOURCE_ENDPOINTS.STORAGE,
        RESOURCE_ENDPOINTS.STORAGE_LIST
      ],
      index: {
        titles: [{ label: 'KHU VỰC', value: 'area' }, { label: 'KHU VỰC CON', value: 'area children', children: true }],
        columns: ['stt', 'avatar', 'name', 'parent', 'country', 'star', 'rating', 'view_count', 'created_at', 'updated_at', 'language', 'actions'],
        actions: ['public', 'private', 'edit', 'detail', 'booking', 'delete'],
        headerActions: ['add', 'filter', 'reset', 'synchronize', 'import', 'export'],
        excelColumns: ['id', 'name', 'ordered', 'vrtour', 'description', 'content', 'vehicle_info_desc', 'vehicle_info', 'local_cuisine_desc', 'local_cuisine', 'travel_experience_desc', 'travel_experience', 'festival_info_desc', 'festival_info', 'fun_facts_desc', 'fun_facts', 'status', 'category_id', 'location_address', 'location_longitude', 'location_latitude', 'country_id', 'youtube_links']
      },
      show: {
        inputs: ['name', 'ordered', 'vrtour', 'vrtour_trailer', 'description', 'content', 'vehicle_info', 'local_cuisine', 'travel_experience', 'festival_info', 'fun_facts'],
        leftCards: ['rating', 'groups'],
        rightCards: [
          'display',
          'category',
          'address',
          'youtube',
          'audios',
          'documents',
          'pictures',
          'videos'
        ]
      },
      detail: [
        'area',
        'dashboard',
        'kiosk',
        'lookup',
        'attraction',
        'museum',
        'event',
        'stay',
        'cuisine',
        'entertainment',
        'company',
        'health',
        'real-estate',
        'government-agency',
        'financial',
        'golf',
        'restaurant',
        'craft-village',
        'travel-experience',
        'other',
        'campaign',
        'post',
        'tour'
      ]
    },
    {
      title: 'Trang chủ',
      view: 'shared',
      name: 'Dashboard',
      type: 'dashboard',
      icon: 'fas fa-home',
      apiEndpoints: [
        RESOURCE_ENDPOINTS.PLACE,
        RESOURCE_ENDPOINTS.PLACE_ENABLE,
        RESOURCE_ENDPOINTS.PLACE_LIST,
        RESOURCE_ENDPOINTS.PLACE_RATINGS,
        RESOURCE_ENDPOINTS.ARTIFACT,
        RESOURCE_ENDPOINTS.ARTIFACT_LIST,
        RESOURCE_ENDPOINTS.ARTIFACT_CLASSIFICATION,
        RESOURCE_ENDPOINTS.GROUP,
        RESOURCE_ENDPOINTS.GROUP_ITEM,
        RESOURCE_ENDPOINTS.STORAGE,
        RESOURCE_ENDPOINTS.STORAGE_LIST,
        RESOURCE_ENDPOINTS.DISPLAY_MODELS,
        RESOURCE_ENDPOINTS.PLACE_CATEGORIES,
        RESOURCE_ENDPOINTS.TAG,
        RESOURCE_ENDPOINTS.HIERARCHY,
        RESOURCE_ENDPOINTS.HIERARCHY_ITEM
      ],
      index: {
        titles: [{ label: 'TRANG CHỦ', value: 'dashboard' }],
        columns: ['stt', 'avatar', 'name', 'country', 'organization', 'star', 'rating', 'view_count', 'created_at', 'updated_at', 'language', 'actions'],
        actions: ['copy', 'showQR', 'public', 'private', 'edit', 'detail', 'booking', 'delete'],
        headerActions: ['add', 'filter', 'reset', 'synchronize', 'import', 'export'],
        excelColumns: ['id', 'name', 'ordered', 'qr_code', 'vrtour', 'vrtour_trailer', 'description', 'content', 'navigation', 'route_map', 'status', 'price_info', 'opening_time', 'opening_day', 'location_address', 'location_longitude', 'location_latitude', 'country_id', 'area_id', 'contact_info_phone', 'contact_info_email', 'contact_info_website', 'facebook_url', 'zalo_url', 'category_id', 'tags', 'youtube_links']
      },
      show: {
        inputs: ['name', 'ordered', 'qr_code', 'vrtour', 'vrtour_trailer', 'vrtour_trailer', 'description', 'content', 'navigation', 'route_map'],
        leftCards: ['rating', 'artifacts', 'artifact_groups', 'groups', 'background'],
        rightCards: [
          // 'packages',//
          'place_parent',
          'display',
          'display_model',
          'price',
          'days',
          'hours',
          'address',
          'contact',
          'category',
          'tags',
          'youtube',
          'audios',
          'documents',
          'pictures',
          'videos'
        ]
      },
      detail: [
        'kiosk',
        'lookup',
        'museum',
        'lookup',
        'hierarchy'
      ]
    },
    {
      title: 'Không gian văn hoá',
      view: 'shared',
      name: 'Museum',
      type: 'museum',
      icon: 'fas fa-mosque',
      apiEndpoints: [
        RESOURCE_ENDPOINTS.PLACE,
        RESOURCE_ENDPOINTS.PLACE_ENABLE,
        RESOURCE_ENDPOINTS.PLACE_LIST,
        RESOURCE_ENDPOINTS.PLACE_RELATED,
        RESOURCE_ENDPOINTS.PLACE_RATINGS,
        RESOURCE_ENDPOINTS.ARTIFACT,
        RESOURCE_ENDPOINTS.ARTIFACT_LIST,
        RESOURCE_ENDPOINTS.ARTIFACT_CLASSIFICATION,
        RESOURCE_ENDPOINTS.GROUP,
        RESOURCE_ENDPOINTS.GROUP_ITEM,
        RESOURCE_ENDPOINTS.STORAGE,
        RESOURCE_ENDPOINTS.STORAGE_LIST,
        RESOURCE_ENDPOINTS.DISPLAY_MODELS,
        RESOURCE_ENDPOINTS.PLACE_CATEGORIES,
        RESOURCE_ENDPOINTS.TAG,
        RESOURCE_ENDPOINTS.HIERARCHY,
        RESOURCE_ENDPOINTS.HIERARCHY_ITEM
      ],
      index: {
        titles: [{ label: 'KHÔNG GIAN VĂN HOÁ', value: 'museum' }, { label: 'KHÔNG GIAN VĂN HOÁ CON', value: 'museum children', children: true }],
        columns: ['stt', 'avatar', 'name', 'parent', 'organization', 'star', 'rating', 'view_count', 'created_at', 'updated_at', 'language', 'actions'],
        actions: ['copy', 'showQR', 'public', 'private', 'edit', 'detail', 'related', 'booking', 'delete'],
        headerActions: ['add', 'filter', 'reset', 'synchronize', 'import', 'export'],
        excelColumns: ['id', 'name', 'ordered', 'qr_code', 'vrtour', 'vrtour_trailer', 'description', 'content', 'navigation', 'route_map', 'status', 'price_info', 'opening_time', 'opening_day', 'location_address', 'location_longitude', 'location_latitude', 'country_id', 'area_id', 'contact_info_phone', 'contact_info_email', 'contact_info_website', 'facebook_url', 'zalo_url', 'category_id', 'tags', 'youtube_links']
      },
      show: {
        inputs: ['name', 'ordered', 'qr_code', 'vrtour', 'vrtour_trailer', 'description', 'content', 'navigation', 'route_map'],
        leftCards: ['rating', 'artifacts', 'artifact_groups', 'groups', 'background'],
        rightCards: [
          // 'packages',//
          'place_parent',
          'display',
          'display_model',
          'structure',
          'price',
          'days',
          'hours',
          'address',
          'contact',
          'category',
          'tags',
          'youtube',
          'audios',
          'documents',
          'pictures',
          'videos'
        ]
      },
      detail: [
        'kiosk',
        'museum',
        'lookup',
        'tour',
        'post',
        'hierarchy'
      ],
      related: [
        'museum',
        'attraction',
        'event'
      ]
    },
    {
      title: 'Nhân vật',
      view: 'shared',
      name: 'People',
      type: 'people',
      icon: 'fas fa-user',
      apiEndpoints: [
        RESOURCE_ENDPOINTS.PLACE,
        RESOURCE_ENDPOINTS.PLACE_ENABLE,
        RESOURCE_ENDPOINTS.PLACE_LIST,
        RESOURCE_ENDPOINTS.PLACE_RELATED,
        RESOURCE_ENDPOINTS.PLACE_RATINGS,
        RESOURCE_ENDPOINTS.ARTIFACT,
        RESOURCE_ENDPOINTS.ARTIFACT_LIST,
        RESOURCE_ENDPOINTS.ARTIFACT_CLASSIFICATION,
        RESOURCE_ENDPOINTS.GROUP,
        RESOURCE_ENDPOINTS.GROUP_ITEM,
        RESOURCE_ENDPOINTS.STORAGE,
        RESOURCE_ENDPOINTS.STORAGE_LIST,
        RESOURCE_ENDPOINTS.PLACE_CATEGORIES,
        RESOURCE_ENDPOINTS.TAG,
        RESOURCE_ENDPOINTS.HIERARCHY,
        RESOURCE_ENDPOINTS.HIERARCHY_ITEM
      ],
      index: {
        titles: [{ label: 'Nhân vật', value: 'people' }, { label: 'Nhân vật con', value: 'people children', children: true }],
        columns: ['stt', 'avatar', 'name', 'parent', 'organization', 'star', 'rating', 'view_count', 'created_at', 'updated_at', 'language', 'actions'],
        actions: ['copy', 'showQR', 'public', 'private', 'edit', 'detail', 'related', 'booking', 'delete'],
        headerActions: ['add', 'filter', 'reset', 'synchronize', 'import', 'export'],
        excelColumns: ['id', 'name', 'ordered', 'qr_code', 'vrtour', 'vrtour_trailer', 'description', 'content', 'status', 'date_of_birth', 'date_of_death', 'location_address', 'location_longitude', 'location_latitude', 'country_id', 'area_id', 'contact_info_phone', 'contact_info_email', 'contact_info_website', 'facebook_url', 'zalo_url', 'category_id', 'tags', 'youtube_links']
      },
      show: {
        inputs: ['name', 'ordered', 'qr_code', 'vrtour', 'vrtour_trailer', 'description', 'content'],
        leftCards: ['rating', 'artifacts', 'artifact_groups', 'groups', 'background'],
        rightCards: [
          // 'packages',//
          'place_parent',
          'display',
          'date_of_birth',
          'address',
          'contact',
          'category',
          'tags',
          'youtube',
          'audios',
          'documents',
          'pictures',
          'videos'
        ]
      },
      detail: [
        'tour',
        'post',
        'hierarchy'
      ],
      related: [
        'museum',
        'attraction',
        'event'
      ]
    },
    {
      title: 'Reviewer',
      view: 'shared',
      name: 'Reviewer',
      type: 'reviewer',
      icon: 'fas fa-user',
      apiEndpoints: [
        RESOURCE_ENDPOINTS.PLACE,
        RESOURCE_ENDPOINTS.PLACE_ENABLE,
        RESOURCE_ENDPOINTS.PLACE_LIST,
        RESOURCE_ENDPOINTS.PLACE_RELATED,
        RESOURCE_ENDPOINTS.PLACE_RATINGS,
        RESOURCE_ENDPOINTS.ARTIFACT,
        RESOURCE_ENDPOINTS.ARTIFACT_LIST,
        RESOURCE_ENDPOINTS.ARTIFACT_CLASSIFICATION,
        RESOURCE_ENDPOINTS.GROUP,
        RESOURCE_ENDPOINTS.GROUP_ITEM,
        RESOURCE_ENDPOINTS.STORAGE,
        RESOURCE_ENDPOINTS.STORAGE_LIST,
        RESOURCE_ENDPOINTS.PLACE_CATEGORIES,
        RESOURCE_ENDPOINTS.TAG,
        RESOURCE_ENDPOINTS.HIERARCHY,
        RESOURCE_ENDPOINTS.HIERARCHY_ITEM
      ],
      index: {
        titles: [{ label: 'Reviewer', value: 'reviewer' }, { label: 'Reviewer con', value: 'reviewer children', children: true }],
        columns: ['stt', 'avatar', 'name', 'parent', 'organization', 'star', 'rating', 'view_count', 'created_at', 'updated_at', 'language', 'actions'],
        actions: ['copy', 'showQR', 'public', 'private', 'edit', 'detail', 'related', 'booking', 'delete'],
        headerActions: ['add', 'filter', 'reset', 'synchronize', 'import', 'export'],
        excelColumns: ['id', 'name', 'ordered', 'qr_code', 'vrtour', 'vrtour_trailer', 'description', 'content', 'status', 'date_of_birth', 'date_of_death', 'location_address', 'location_longitude', 'location_latitude', 'country_id', 'area_id', 'contact_info_phone', 'contact_info_email', 'contact_info_website', 'facebook_url', 'zalo_url', 'category_id', 'tags', 'youtube_links']
      },
      show: {
        inputs: ['name', 'ordered', 'qr_code', 'vrtour', 'vrtour_trailer', 'description', 'content'],
        leftCards: ['rating', 'artifacts', 'artifact_groups', 'groups', 'background'],
        rightCards: [
          // 'packages',//
          'place_parent',
          'display',
          'date_of_birth',
          'address',
          'contact',
          'category',
          'tags',
          'youtube',
          'audios',
          'documents',
          'pictures',
          'videos'
        ]
      },
      detail: [
        'tour',
        'post',
        'hierarchy'
      ],
      related: [
        'museum',
        'attraction',
        'event'
      ]
    },
    {
      title: 'Kiosk',
      view: 'shared',
      name: 'Kiosk',
      type: 'kiosk',
      icon: 'fas fa-tablet-alt',
      apiEndpoints: [
        RESOURCE_ENDPOINTS.PLACE,
        RESOURCE_ENDPOINTS.PLACE_ENABLE,
        RESOURCE_ENDPOINTS.PLACE_LIST,
        RESOURCE_ENDPOINTS.PLACE_RATINGS,
        RESOURCE_ENDPOINTS.ARTIFACT,
        RESOURCE_ENDPOINTS.ARTIFACT_LIST,
        RESOURCE_ENDPOINTS.ARTIFACT_CLASSIFICATION,
        RESOURCE_ENDPOINTS.GROUP,
        RESOURCE_ENDPOINTS.GROUP_ITEM,
        RESOURCE_ENDPOINTS.STORAGE,
        RESOURCE_ENDPOINTS.STORAGE_LIST,
        RESOURCE_ENDPOINTS.PLACE_CATEGORIES,
        RESOURCE_ENDPOINTS.TAG,
        RESOURCE_ENDPOINTS.HIERARCHY,
        RESOURCE_ENDPOINTS.HIERARCHY_ITEM
      ],
      index: {
        titles: [{ label: 'KIOSK', value: 'kiosk' }],
        columns: ['stt', 'avatar', 'name', 'organization', 'star', 'rating', 'view_count', 'created_at', 'updated_at', 'language', 'actions'],
        actions: ['public', 'private', 'edit', 'detail', 'booking', 'delete'],
        headerActions: ['add', 'filter', 'reset', 'synchronize', 'import', 'export'],
        excelColumns: ['id', 'name', 'ordered', 'qr_code', 'vrtour', 'vrtour_trailer', 'description', 'content', 'status', 'location_address', 'location_longitude', 'location_latitude', 'country_id', 'area_id', 'contact_info_phone', 'contact_info_email', 'contact_info_website', 'facebook_url', 'zalo_url', 'category_id', 'tags', 'youtube_links']
      },
      show: {
        inputs: ['name', 'ordered', 'vrtour', 'vrtour_trailer', 'description', 'content'],
        leftCards: ['rating', 'artifacts', 'artifact_groups', 'groups', 'background'],
        rightCards: [
          'place_parent',
          'display',
          'structure',
          'address',
          'contact',
          'category',
          'tags',
          'youtube',
          'audios',
          'documents',
          'pictures',
          'videos'
        ]
      },
      detail: [
        'lookup',
        'hierarchy'
      ]
    },
    {
      title: 'Tra cứu',
      view: 'shared',
      name: 'Lookup',
      type: 'lookup',
      icon: 'fas fa-filter',
      apiEndpoints: [
        RESOURCE_ENDPOINTS.PLACE,
        RESOURCE_ENDPOINTS.PLACE_ENABLE,
        RESOURCE_ENDPOINTS.PLACE_LIST,
        RESOURCE_ENDPOINTS.PLACE_RATINGS,
        RESOURCE_ENDPOINTS.ARTIFACT,
        RESOURCE_ENDPOINTS.ARTIFACT_LIST,
        RESOURCE_ENDPOINTS.ARTIFACT_CLASSIFICATION,
        RESOURCE_ENDPOINTS.GROUP,
        RESOURCE_ENDPOINTS.GROUP_ITEM,
        RESOURCE_ENDPOINTS.STORAGE,
        RESOURCE_ENDPOINTS.STORAGE_LIST,
        RESOURCE_ENDPOINTS.PLACE_CATEGORIES,
        RESOURCE_ENDPOINTS.TAG,
        RESOURCE_ENDPOINTS.HIERARCHY,
        RESOURCE_ENDPOINTS.HIERARCHY_ITEM
      ],
      index: {
        titles: [{ label: 'TRA CỨU', value: 'lookup' }, { label: 'TRA CỨU CON', value: 'lookup children', children: true }],
        columns: ['stt', 'avatar', 'name', 'organization', 'star', 'rating', 'view_count', 'created_at', 'updated_at', 'language', 'actions'],
        actions: ['public', 'private', 'edit', 'detail', 'booking', 'delete'],
        headerActions: ['add', 'filter', 'reset', 'synchronize', 'import', 'export'],
        excelColumns: ['id', 'name', 'ordered', 'qr_code', 'vrtour', 'vrtour_trailer', 'description', 'content', 'status', 'location_address', 'location_longitude', 'location_latitude', 'country_id', 'area_id', 'contact_info_phone', 'contact_info_email', 'contact_info_website', 'facebook_url', 'zalo_url', 'category_id', 'tags', 'youtube_links']
      },
      show: {
        inputs: ['name', 'ordered', 'vrtour', 'vrtour_trailer', 'description', 'content'],
        leftCards: ['rating', 'artifacts', 'artifact_groups', 'groups', 'background'],
        rightCards: [
          'place_parent',
          'display',
          'structure',
          'address',
          'contact',
          'category',
          'tags',
          'youtube',
          'audios',
          'documents',
          'pictures',
          'videos'
        ]
      },
      detail: [
        'lookup',
        'hierarchy'
      ]
    },
    {
      title: 'Danh thắng',
      view: 'shared',
      name: 'Attraction',
      type: 'attraction',
      icon: 'fas fa-place-of-worship',
      apiEndpoints: [
        RESOURCE_ENDPOINTS.PLACE,
        RESOURCE_ENDPOINTS.PLACE_ENABLE,
        RESOURCE_ENDPOINTS.PLACE_LIST,
        RESOURCE_ENDPOINTS.PLACE_RATINGS,
        RESOURCE_ENDPOINTS.ARTIFACT,
        RESOURCE_ENDPOINTS.ARTIFACT_LIST,
        RESOURCE_ENDPOINTS.ARTIFACT_CLASSIFICATION,
        RESOURCE_ENDPOINTS.GROUP,
        RESOURCE_ENDPOINTS.GROUP_ITEM,
        RESOURCE_ENDPOINTS.STORAGE,
        RESOURCE_ENDPOINTS.STORAGE_LIST,
        RESOURCE_ENDPOINTS.PLACE_CATEGORIES,
        RESOURCE_ENDPOINTS.TAG,
        RESOURCE_ENDPOINTS.HIERARCHY,
        RESOURCE_ENDPOINTS.HIERARCHY_ITEM
      ],
      index: {
        titles: [{ label: 'DANH THẮNG', value: 'attraction' }, { label: 'DANH THẮNG CON', value: 'attraction children', children: true }],
        columns: ['stt', 'avatar', 'name', 'parent', 'organization', 'star', 'rating', 'view_count', 'created_at', 'updated_at', 'language', 'actions'],
        actions: ['copy', 'showQR', 'public', 'private', 'edit', 'detail', 'booking', 'delete'],
        headerActions: ['add', 'filter', 'reset', 'synchronize', 'import', 'export'],
        excelColumns: ['id', 'name', 'ordered', 'qr_code', 'vrtour', 'vrtour_trailer', 'description', 'content', 'navigation', 'route_map', 'status', 'price_info', 'opening_time', 'opening_day', 'location_address', 'location_longitude', 'location_latitude', 'country_id', 'area_id', 'contact_info_phone', 'contact_info_email', 'contact_info_website', 'facebook_url', 'zalo_url', 'category_id', 'tags', 'youtube_links']
      },
      show: {
        inputs: ['name', 'qr_code', 'ordered', 'vrtour', 'vrtour_trailer', 'description', 'content', 'navigation', 'route_map'],
        leftCards: ['rating', 'artifacts', 'artifact_groups', 'groups', 'background'],
        rightCards: [
          // 'packages',//
          'place_parent',
          'display',
          'price',
          'days',
          'hours',
          'address',
          'contact',
          'category',
          'tags',
          'youtube',
          'audios',
          'documents',
          'pictures',
          'videos'
        ]
      },
      detail: [
        'attraction',
        'tour',
        'post',
        'hierarchy'
      ]
    },
    {
      title: 'Giao thông',
      view: 'shared',
      name: 'Traffic',
      type: 'traffic',
      icon: 'fas fa-traffic-light',
      apiEndpoints: [
        RESOURCE_ENDPOINTS.PLACE,
        RESOURCE_ENDPOINTS.PLACE_ENABLE,
        RESOURCE_ENDPOINTS.PLACE_LIST,
        RESOURCE_ENDPOINTS.PLACE_RATINGS,
        RESOURCE_ENDPOINTS.ARTIFACT,
        RESOURCE_ENDPOINTS.ARTIFACT_LIST,
        RESOURCE_ENDPOINTS.ARTIFACT_CLASSIFICATION,
        RESOURCE_ENDPOINTS.GROUP,
        RESOURCE_ENDPOINTS.GROUP_ITEM,
        RESOURCE_ENDPOINTS.STORAGE,
        RESOURCE_ENDPOINTS.STORAGE_LIST,
        RESOURCE_ENDPOINTS.PLACE_CATEGORIES,
        RESOURCE_ENDPOINTS.TAG,
        RESOURCE_ENDPOINTS.HIERARCHY,
        RESOURCE_ENDPOINTS.HIERARCHY_ITEM
      ],
      index: {
        titles: [{ label: 'GIAO THÔNG', value: 'traffic' }],
        columns: ['stt', 'avatar', 'name', 'parent', 'organization', 'star', 'rating', 'view_count', 'created_at', 'updated_at', 'language', 'actions'],
        actions: ['copy', 'showQR', 'public', 'private', 'edit', 'detail', 'booking', 'delete'],
        headerActions: ['add', 'filter', 'reset', 'synchronize', 'import', 'export'],
        excelColumns: ['id', 'name', 'ordered', 'qr_code', 'vrtour', 'vrtour_trailer', 'description', 'content', 'navigation', 'route_map', 'status', 'price_info', 'opening_time', 'opening_day', 'location_address', 'location_longitude', 'location_latitude', 'country_id', 'area_id', 'contact_info_phone', 'contact_info_email', 'contact_info_website', 'facebook_url', 'zalo_url', 'category_id', 'tags', 'youtube_links']
      },
      show: {
        inputs: ['name', 'qr_code', 'ordered', 'vrtour', 'vrtour_trailer', 'description', 'content', 'navigation', 'route_map'],
        leftCards: ['rating', 'artifacts', 'artifact_groups', 'groups', 'background'],
        rightCards: [
          // 'packages',//
          'place_parent',
          'display',
          'price',
          'days',
          'hours',
          'address',
          'contact',
          'category',
          'tags',
          'youtube',
          'audios',
          'documents',
          'pictures',
          'videos'
        ]
      },
      detail: [
        'attraction',
        'tour',
        'post',
        'hierarchy'
      ]
    },
    {
      title: 'Sự kiện và triển lãm',
      view: 'shared',
      name: 'Event',
      type: 'event',
      icon: 'fas fa-calendar-week',
      apiEndpoints: [
        RESOURCE_ENDPOINTS.PLACE,
        RESOURCE_ENDPOINTS.PLACE_ENABLE,
        RESOURCE_ENDPOINTS.PLACE_LIST,
        RESOURCE_ENDPOINTS.PLACE_RATINGS,
        RESOURCE_ENDPOINTS.ARTIFACT,
        RESOURCE_ENDPOINTS.ARTIFACT_LIST,
        RESOURCE_ENDPOINTS.ARTIFACT_CLASSIFICATION,
        RESOURCE_ENDPOINTS.GROUP,
        RESOURCE_ENDPOINTS.GROUP_ITEM,
        RESOURCE_ENDPOINTS.STORAGE,
        RESOURCE_ENDPOINTS.STORAGE_LIST,
        RESOURCE_ENDPOINTS.PLACE_CATEGORIES,
        RESOURCE_ENDPOINTS.TAG,
        RESOURCE_ENDPOINTS.HIERARCHY,
        RESOURCE_ENDPOINTS.HIERARCHY_ITEM
      ],
      index: {
        titles: [{ label: 'SỰ KIỆN VÀ TRIỂN LÃM', value: 'event' }],
        columns: ['stt', 'avatar', 'name', 'organization', 'star', 'rating', 'view_count', 'created_at', 'updated_at', 'language', 'actions'],
        actions: ['showQR', 'public', 'private', 'edit', 'detail', 'booking', 'delete'],
        headerActions: ['add', 'filter', 'reset', 'synchronize', 'import', 'export'],
        excelColumns: ['id', 'name', 'ordered', 'qr_code', 'vrtour', 'vrtour_trailer', 'description', 'content', 'navigation', 'route_map', 'status', 'price_info', 'place_duration', 'opening_time', 'opening_day', 'location_address', 'location_longitude', 'location_latitude', 'country_id', 'area_id', 'contact_info_phone', 'contact_info_email', 'contact_info_website', 'facebook_url', 'zalo_url', 'category_id', 'tags', 'youtube_links']
      },
      show: {
        inputs: ['name', 'qr_code', 'ordered', 'vrtour', 'vrtour_trailer', 'description', 'content', 'navigation', 'route_map'],
        leftCards: ['rating', 'artifacts', 'artifact_groups', 'groups', 'background'],
        rightCards: [
          // 'packages',//
          'place_parent',
          'display',
          'price',
          'times',
          'days',
          'hours',
          'address',
          'contact',
          'category',
          'tags',
          'youtube',
          'audios',
          'documents',
          'pictures',
          'videos'
        ]
      },
      detail: [
        'tour',
        'post',
        'hierarchy'
      ]
    },
    {
      title: 'Lễ hội',
      view: 'shared',
      name: 'Festival',
      type: 'festival',
      icon: 'fas fa-american-sign-language-interpreting',
      apiEndpoints: [
        RESOURCE_ENDPOINTS.PLACE,
        RESOURCE_ENDPOINTS.PLACE_ENABLE,
        RESOURCE_ENDPOINTS.PLACE_LIST,
        RESOURCE_ENDPOINTS.PLACE_RATINGS,
        RESOURCE_ENDPOINTS.ARTIFACT,
        RESOURCE_ENDPOINTS.ARTIFACT_LIST,
        RESOURCE_ENDPOINTS.ARTIFACT_CLASSIFICATION,
        RESOURCE_ENDPOINTS.GROUP,
        RESOURCE_ENDPOINTS.GROUP_ITEM,
        RESOURCE_ENDPOINTS.STORAGE,
        RESOURCE_ENDPOINTS.STORAGE_LIST,
        RESOURCE_ENDPOINTS.PLACE_CATEGORIES,
        RESOURCE_ENDPOINTS.TAG,
        RESOURCE_ENDPOINTS.HIERARCHY,
        RESOURCE_ENDPOINTS.HIERARCHY_ITEM
      ],
      index: {
        titles: [{ label: 'Lễ hội', value: 'festival' }],
        columns: ['stt', 'avatar', 'name', 'organization', 'star', 'rating', 'view_count', 'created_at', 'updated_at', 'language', 'actions'],
        actions: ['showQR', 'public', 'private', 'edit', 'detail', 'booking', 'delete'],
        headerActions: ['add', 'filter', 'reset', 'synchronize', 'import', 'export'],
        excelColumns: ['id', 'name', 'ordered', 'qr_code', 'vrtour', 'vrtour_trailer', 'description', 'content', 'navigation', 'route_map', 'status', 'price_info', 'place_duration', 'opening_time', 'opening_day', 'location_address', 'location_longitude', 'location_latitude', 'country_id', 'area_id', 'contact_info_phone', 'contact_info_email', 'contact_info_website', 'facebook_url', 'zalo_url', 'category_id', 'tags', 'youtube_links']
      },
      show: {
        inputs: ['name', 'qr_code', 'ordered', 'vrtour', 'vrtour_trailer', 'description', 'content', 'navigation', 'route_map'],
        leftCards: ['rating', 'artifacts', 'artifact_groups', 'groups', 'background'],
        rightCards: [
          // 'packages',//
          'place_parent',
          'display',
          'price',
          'times',
          'days',
          'hours',
          'address',
          'contact',
          'category',
          'tags',
          'youtube',
          'audios',
          'documents',
          'pictures',
          'videos'
        ]
      },
      detail: [
        'tour',
        'post',
        'hierarchy'
      ]
    },
    {
      title: 'Gia đình',
      view: 'shared',
      name: 'Family',
      type: 'family',
      icon: 'fas fa-house-user',
      apiEndpoints: [
        RESOURCE_ENDPOINTS.PLACE,
        RESOURCE_ENDPOINTS.PLACE_ENABLE,
        RESOURCE_ENDPOINTS.PLACE_LIST,
        RESOURCE_ENDPOINTS.PLACE_RATINGS,
        RESOURCE_ENDPOINTS.ARTIFACT,
        RESOURCE_ENDPOINTS.ARTIFACT_LIST,
        RESOURCE_ENDPOINTS.ARTIFACT_CLASSIFICATION,
        RESOURCE_ENDPOINTS.GROUP,
        RESOURCE_ENDPOINTS.GROUP_ITEM,
        RESOURCE_ENDPOINTS.STORAGE,
        RESOURCE_ENDPOINTS.STORAGE_LIST,
        RESOURCE_ENDPOINTS.PLACE_CATEGORIES,
        RESOURCE_ENDPOINTS.TAG,
        RESOURCE_ENDPOINTS.HIERARCHY,
        RESOURCE_ENDPOINTS.HIERARCHY_ITEM
      ],
      index: {
        titles: [{ label: 'GIA ĐÌNH', value: 'family' }],
        columns: ['stt', 'avatar', 'name', 'organization', 'star', 'rating', 'view_count', 'created_at', 'updated_at', 'language', 'actions'],
        actions: ['showQR', 'public', 'private', 'edit', 'detail', 'booking', 'delete'],
        headerActions: ['add', 'filter', 'reset', 'synchronize', 'import', 'export'],
        excelColumns: ['id', 'name', 'ordered', 'qr_code', 'vrtour', 'vrtour_trailer', 'description', 'content', 'navigation', 'route_map', 'status', 'price_info', 'place_duration', 'opening_time', 'opening_day', 'location_address', 'location_longitude', 'location_latitude', 'country_id', 'area_id', 'contact_info_phone', 'contact_info_email', 'contact_info_website', 'facebook_url', 'zalo_url', 'category_id', 'tags', 'youtube_links']
      },
      show: {
        inputs: ['name', 'qr_code', 'ordered', 'vrtour', 'vrtour_trailer', 'description', 'content', 'navigation', 'route_map'],
        leftCards: ['rating', 'artifacts', 'artifact_groups', 'groups', 'background'],
        rightCards: [
          // 'packages',//
          'place_parent',
          'display',
          'price',
          'times',
          'days',
          'hours',
          'address',
          'contact',
          'category',
          'tags',
          'youtube',
          'audios',
          'documents',
          'pictures',
          'videos'
        ]
      },
      detail: [
        'tour',
        'post',
        'hierarchy'
      ]
    },
    {
      title: 'Địa điểm lưu trú',
      view: 'shared',
      name: 'Stay',
      type: 'stay',
      icon: 'fas fa-bed',
      apiEndpoints: [
        RESOURCE_ENDPOINTS.PLACE,
        RESOURCE_ENDPOINTS.PLACE_ENABLE,
        RESOURCE_ENDPOINTS.PLACE_LIST,
        RESOURCE_ENDPOINTS.PLACE_RATINGS,
        RESOURCE_ENDPOINTS.PLACE_FACILITIES,
        RESOURCE_ENDPOINTS.PLACE_SERVICES,
        RESOURCE_ENDPOINTS.ROOM_TYPE,
        RESOURCE_ENDPOINTS.ROOM_TYPE_LIST,
        RESOURCE_ENDPOINTS.ARTIFACT,
        RESOURCE_ENDPOINTS.ARTIFACT_LIST,
        RESOURCE_ENDPOINTS.ARTIFACT_CLASSIFICATION,
        RESOURCE_ENDPOINTS.GROUP,
        RESOURCE_ENDPOINTS.GROUP_ITEM,
        RESOURCE_ENDPOINTS.STORAGE,
        RESOURCE_ENDPOINTS.STORAGE_LIST,
        RESOURCE_ENDPOINTS.PLACE_CATEGORIES,
        RESOURCE_ENDPOINTS.TAG,
        RESOURCE_ENDPOINTS.HIERARCHY,
        RESOURCE_ENDPOINTS.HIERARCHY_ITEM
      ],
      index: {
        titles: [{ label: 'ĐỊA ĐIỂM LƯU TRÚ', value: 'stay' }],
        columns: ['stt', 'avatar', 'name', 'organization', 'star', 'rating', 'view_count', 'created_at', 'updated_at', 'language', 'actions'],
        actions: ['showQR', 'public', 'private', 'edit', 'detail', 'booking', 'delete'],
        headerActions: ['add', 'filter', 'reset', 'synchronize', 'import', 'export'],
        excelColumns: ['id', 'name', 'ordered', 'qr_code', 'vrtour', 'description', 'content', 'status', 'price_info', 'opening_time', 'opening_day', 'location_address', 'location_longitude', 'location_latitude', 'country_id', 'area_id', 'contact_info_phone', 'contact_info_email', 'contact_info_website', 'facebook_url', 'zalo_url', 'category_id', 'tags', 'youtube_links']
      },
      show: {
        inputs: ['name', 'ordered', 'qr_code', 'vrtour', 'description', 'content'],
        leftCards: ['rating', 'facility', 'services', 'room_type', 'artifacts', 'artifact_groups', 'groups', 'background'],
        rightCards: [
          'display',
          'star',
          'price',
          'days',
          'hours',
          'address',
          'contact',
          'category',
          'tags',
          'youtube',
          'audios',
          'documents',
          'pictures',
          'videos'
        ]
      },
      detail: [
        'tour',
        'post',
        'hierarchy'
      ]
    },
    {
      title: 'Ăn uống',
      view: 'shared',
      name: 'Cuisine',
      type: 'cuisine',
      icon: 'fas fa-utensils',
      apiEndpoints: [
        RESOURCE_ENDPOINTS.PLACE,
        RESOURCE_ENDPOINTS.PLACE_ENABLE,
        RESOURCE_ENDPOINTS.PLACE_LIST,
        RESOURCE_ENDPOINTS.PLACE_RATINGS,
        RESOURCE_ENDPOINTS.PLACE_SERVICES,
        RESOURCE_ENDPOINTS.ARTIFACT,
        RESOURCE_ENDPOINTS.ARTIFACT_LIST,
        RESOURCE_ENDPOINTS.ARTIFACT_CLASSIFICATION,
        RESOURCE_ENDPOINTS.GROUP,
        RESOURCE_ENDPOINTS.GROUP_ITEM,
        RESOURCE_ENDPOINTS.STORAGE,
        RESOURCE_ENDPOINTS.STORAGE_LIST,
        RESOURCE_ENDPOINTS.PLACE_CATEGORIES,
        RESOURCE_ENDPOINTS.TAG,
        RESOURCE_ENDPOINTS.HIERARCHY,
        RESOURCE_ENDPOINTS.HIERARCHY_ITEM
      ],
      index: {
        titles: [{ label: 'ĂN UỐNG', value: 'cuisine' }],
        columns: ['stt', 'avatar', 'name', 'organization', 'star', 'rating', 'view_count', 'created_at', 'updated_at', 'language', 'actions'],
        actions: ['showQR', 'public', 'private', 'edit', 'detail', 'booking', 'delete'],
        headerActions: ['add', 'filter', 'reset', 'synchronize', 'import', 'export'],
        excelColumns: ['id', 'name', 'ordered', 'qr_code', 'vrtour', 'description', 'content', 'status', 'price_info', 'opening_time', 'opening_day', 'location_address', 'location_longitude', 'location_latitude', 'country_id', 'area_id', 'contact_info_phone', 'contact_info_email', 'contact_info_website', 'facebook_url', 'zalo_url', 'category_id', 'tags', 'youtube_links']
      },
      show: {
        inputs: ['name', 'ordered', 'qr_code', 'vrtour', 'description', 'content'],
        leftCards: ['rating', 'services', 'artifacts', 'artifact_groups', 'groups', 'background'],
        rightCards: [
          'display',
          'price',
          'days',
          'hours',
          'address',
          'contact',
          'category',
          'tags',
          'youtube',
          'audios',
          'documents',
          'pictures',
          'videos'
        ]
      },
      detail: [
        'tour',
        'post',
        'hierarchy'
      ]
    },
    {
      title: 'Giải trí',
      view: 'shared',
      name: 'Entertainment',
      type: 'entertainment',
      icon: 'fas fa-play-circle',
      apiEndpoints: [
        RESOURCE_ENDPOINTS.PLACE,
        RESOURCE_ENDPOINTS.PLACE_ENABLE,
        RESOURCE_ENDPOINTS.PLACE_LIST,
        RESOURCE_ENDPOINTS.PLACE_RATINGS,
        RESOURCE_ENDPOINTS.ARTIFACT,
        RESOURCE_ENDPOINTS.ARTIFACT_LIST,
        RESOURCE_ENDPOINTS.ARTIFACT_CLASSIFICATION,
        RESOURCE_ENDPOINTS.GROUP,
        RESOURCE_ENDPOINTS.GROUP_ITEM,
        RESOURCE_ENDPOINTS.STORAGE,
        RESOURCE_ENDPOINTS.STORAGE_LIST,
        RESOURCE_ENDPOINTS.PLACE_CATEGORIES,
        RESOURCE_ENDPOINTS.TAG,
        RESOURCE_ENDPOINTS.HIERARCHY,
        RESOURCE_ENDPOINTS.HIERARCHY_ITEM
      ],
      index: {
        titles: [{ label: 'GIẢI TRÍ', value: 'entertainment' }],
        columns: ['stt', 'avatar', 'name', 'organization', 'star', 'rating', 'view_count', 'created_at', 'updated_at', 'language', 'actions'],
        actions: ['showQR', 'public', 'private', 'edit', 'detail', 'booking', 'delete'],
        headerActions: ['add', 'filter', 'reset', 'synchronize', 'import', 'export'],
        excelColumns: ['id', 'name', 'ordered', 'qr_code', 'vrtour', 'description', 'content', 'route_map', 'status', 'price_info', 'opening_time', 'opening_day', 'location_address', 'location_longitude', 'location_latitude', 'country_id', 'area_id', 'contact_info_phone', 'contact_info_email', 'contact_info_website', 'facebook_url', 'zalo_url', 'category_id', 'tags', 'youtube_links']
      },
      show: {
        inputs: ['name', 'ordered', 'qr_code', 'vrtour', 'description', 'content', 'route_map'],
        leftCards: ['rating', 'artifacts', 'artifact_groups', 'groups', 'background'],
        rightCards: [
          'display',
          'price',
          'days',
          'hours',
          'address',
          'contact',
          'category',
          'tags',
          'youtube',
          'audios',
          'documents',
          'pictures',
          'videos'
        ]
      },
      detail: [
        'tour',
        'post',
        'hierarchy'
      ]
    },
    {
      title: 'Doanh nghiệp',
      view: 'shared',
      name: 'Company',
      type: 'company',
      icon: 'fas fa-building',
      apiEndpoints: [
        RESOURCE_ENDPOINTS.PLACE,
        RESOURCE_ENDPOINTS.PLACE_ENABLE,
        RESOURCE_ENDPOINTS.PLACE_LIST,
        RESOURCE_ENDPOINTS.PLACE_RATINGS,
        RESOURCE_ENDPOINTS.ARTIFACT,
        RESOURCE_ENDPOINTS.ARTIFACT_LIST,
        RESOURCE_ENDPOINTS.ARTIFACT_CLASSIFICATION,
        RESOURCE_ENDPOINTS.GROUP,
        RESOURCE_ENDPOINTS.GROUP_ITEM,
        RESOURCE_ENDPOINTS.STORAGE,
        RESOURCE_ENDPOINTS.STORAGE_LIST,
        RESOURCE_ENDPOINTS.PLACE_CATEGORIES,
        RESOURCE_ENDPOINTS.TAG,
        RESOURCE_ENDPOINTS.HIERARCHY,
        RESOURCE_ENDPOINTS.HIERARCHY_ITEM
      ],
      index: {
        titles: [{ label: 'DOANH NGHIỆP', value: 'company' }],
        columns: ['stt', 'avatar', 'name', 'organization', 'star', 'rating', 'view_count', 'created_at', 'updated_at', 'language', 'actions'],
        actions: ['showQR', 'public', 'private', 'edit', 'detail', 'booking', 'delete'],
        headerActions: ['add', 'filter', 'reset', 'synchronize', 'import', 'export'],
        excelColumns: ['id', 'name', 'ordered', 'qr_code', 'vrtour', 'description', 'content', 'status', 'price_info', 'opening_time', 'opening_day', 'location_address', 'location_longitude', 'location_latitude', 'country_id', 'area_id', 'contact_info_phone', 'contact_info_email', 'contact_info_website', 'facebook_url', 'zalo_url', 'category_id', 'tags', 'youtube_links']
      },
      show: {
        inputs: ['name', 'ordered', 'qr_code', 'vrtour', 'description', 'content'],
        leftCards: ['rating', 'artifacts', 'artifact_groups', 'groups', 'background'],
        rightCards: [
          'display',
          'price',
          'days',
          'hours',
          'address',
          'contact',
          'category',
          'tags',
          'youtube',
          'audios',
          'documents',
          'pictures',
          'videos'
        ]
      },
      detail: [
        'tour',
        'post',
        'hierarchy'
      ]
    },
    {
      title: 'Chăm sóc sức khỏe',
      view: 'shared',
      name: 'Health',
      type: 'health',
      icon: 'fas fa-heart',
      apiEndpoints: [
        RESOURCE_ENDPOINTS.PLACE,
        RESOURCE_ENDPOINTS.PLACE_ENABLE,
        RESOURCE_ENDPOINTS.PLACE_LIST,
        RESOURCE_ENDPOINTS.PLACE_RATINGS,
        RESOURCE_ENDPOINTS.ARTIFACT,
        RESOURCE_ENDPOINTS.ARTIFACT_LIST,
        RESOURCE_ENDPOINTS.ARTIFACT_CLASSIFICATION,
        RESOURCE_ENDPOINTS.GROUP,
        RESOURCE_ENDPOINTS.GROUP_ITEM,
        RESOURCE_ENDPOINTS.STORAGE,
        RESOURCE_ENDPOINTS.STORAGE_LIST,
        RESOURCE_ENDPOINTS.PLACE_CATEGORIES,
        RESOURCE_ENDPOINTS.TAG,
        RESOURCE_ENDPOINTS.HIERARCHY,
        RESOURCE_ENDPOINTS.HIERARCHY_ITEM
      ],
      index: {
        titles: [{ label: 'CHĂM SÓC SỨC KHỎE', value: 'health' }],
        columns: ['stt', 'avatar', 'name', 'organization', 'star', 'rating', 'view_count', 'created_at', 'updated_at', 'language', 'actions'],
        actions: ['showQR', 'public', 'private', 'edit', 'detail', 'booking', 'delete'],
        headerActions: ['add', 'filter', 'reset', 'synchronize', 'import', 'export'],
        excelColumns: ['id', 'name', 'ordered', 'qr_code', 'vrtour', 'description', 'content', 'status', 'price_info', 'opening_time', 'opening_day', 'location_address', 'location_longitude', 'location_latitude', 'country_id', 'area_id', 'contact_info_phone', 'contact_info_email', 'contact_info_website', 'facebook_url', 'zalo_url', 'category_id', 'tags', 'youtube_links']
      },
      show: {
        inputs: ['name', 'ordered', 'qr_code', 'vrtour', 'description', 'content'],
        leftCards: ['rating', 'artifacts', 'artifact_groups', 'groups', 'background'],
        rightCards: [
          'display',
          'price',
          'days',
          'hours',
          'address',
          'contact',
          'category',
          'tags',
          'youtube',
          'audios',
          'documents',
          'pictures',
          'videos'
        ]
      },
      detail: [
        'tour',
        'post',
        'hierarchy'
      ]
    },
    {
      title: 'Bất động sản',
      view: 'shared',
      name: 'Real-estate',
      type: 'real-estate',
      icon: 'fas fa-landmark',
      apiEndpoints: [
        RESOURCE_ENDPOINTS.PLACE,
        RESOURCE_ENDPOINTS.PLACE_ENABLE,
        RESOURCE_ENDPOINTS.PLACE_LIST,
        RESOURCE_ENDPOINTS.PLACE_RATINGS,
        RESOURCE_ENDPOINTS.ARTIFACT,
        RESOURCE_ENDPOINTS.ARTIFACT_LIST,
        RESOURCE_ENDPOINTS.ARTIFACT_CLASSIFICATION,
        RESOURCE_ENDPOINTS.GROUP,
        RESOURCE_ENDPOINTS.GROUP_ITEM,
        RESOURCE_ENDPOINTS.STORAGE,
        RESOURCE_ENDPOINTS.STORAGE_LIST,
        RESOURCE_ENDPOINTS.PLACE_CATEGORIES,
        RESOURCE_ENDPOINTS.TAG,
        RESOURCE_ENDPOINTS.HIERARCHY,
        RESOURCE_ENDPOINTS.HIERARCHY_ITEM
      ],
      index: {
        titles: [{ label: 'BẤT ĐỘNG SẢN', value: 'real-estate' }],
        columns: ['stt', 'avatar', 'name', 'organization', 'star', 'rating', 'view_count', 'created_at', 'updated_at', 'language', 'actions'],
        actions: ['showQR', 'public', 'private', 'edit', 'detail', 'booking', 'delete'],
        headerActions: ['add', 'filter', 'reset', 'synchronize', 'import', 'export'],
        excelColumns: ['id', 'name', 'ordered', 'qr_code', 'vrtour', 'description', 'content', 'status', 'price_info', 'opening_time', 'opening_day', 'location_address', 'location_longitude', 'location_latitude', 'country_id', 'area_id', 'contact_info_phone', 'contact_info_email', 'contact_info_website', 'facebook_url', 'zalo_url', 'category_id', 'tags', 'youtube_links']
      },
      show: {
        inputs: ['name', 'ordered', 'qr_code', 'vrtour', 'description', 'content'],
        leftCards: ['rating', 'artifacts', 'artifact_groups', 'groups', 'background'],
        rightCards: [
          'display',
          'price',
          'days',
          'hours',
          'address',
          'contact',
          'category',
          'tags',
          'youtube',
          'audios',
          'documents',
          'pictures',
          'videos'
        ]
      },
      detail: [
        'tour',
        'post',
        'hierarchy'
      ]
    },
    {
      title: 'Cơ quan nhà nước',
      view: 'shared',
      name: 'Government-agency',
      type: 'government-agency',
      icon: 'fas fa-building',
      apiEndpoints: [
        RESOURCE_ENDPOINTS.PLACE,
        RESOURCE_ENDPOINTS.PLACE_ENABLE,
        RESOURCE_ENDPOINTS.PLACE_LIST,
        RESOURCE_ENDPOINTS.PLACE_RATINGS,
        RESOURCE_ENDPOINTS.ARTIFACT,
        RESOURCE_ENDPOINTS.ARTIFACT_LIST,
        RESOURCE_ENDPOINTS.ARTIFACT_CLASSIFICATION,
        RESOURCE_ENDPOINTS.GROUP,
        RESOURCE_ENDPOINTS.GROUP_ITEM,
        RESOURCE_ENDPOINTS.STORAGE,
        RESOURCE_ENDPOINTS.STORAGE_LIST,
        RESOURCE_ENDPOINTS.PLACE_CATEGORIES,
        RESOURCE_ENDPOINTS.TAG,
        RESOURCE_ENDPOINTS.HIERARCHY,
        RESOURCE_ENDPOINTS.HIERARCHY_ITEM
      ],
      index: {
        titles: [{ label: 'CƠ QUAN NHÀ NƯỚC', value: 'government-agency' }],
        columns: ['stt', 'avatar', 'name', 'organization', 'star', 'rating', 'view_count', 'created_at', 'updated_at', 'language', 'actions'],
        actions: ['showQR', 'public', 'private', 'edit', 'detail', 'booking', 'delete'],
        headerActions: ['add', 'filter', 'reset', 'synchronize', 'import', 'export'],
        excelColumns: ['id', 'name', 'ordered', 'qr_code', 'vrtour', 'description', 'content', 'status', 'price_info', 'opening_time', 'opening_day', 'location_address', 'location_longitude', 'location_latitude', 'country_id', 'area_id', 'contact_info_phone', 'contact_info_email', 'contact_info_website', 'facebook_url', 'zalo_url', 'category_id', 'tags', 'youtube_links']
      },
      show: {
        inputs: ['name', 'ordered', 'qr_code', 'vrtour', 'description', 'content'],
        leftCards: ['rating', 'artifacts', 'artifact_groups', 'groups', 'background'],
        rightCards: [
          'display',
          'price',
          'days',
          'hours',
          'address',
          'contact',
          'category',
          'tags',
          'youtube',
          'audios',
          'documents',
          'pictures',
          'videos'
        ]
      },
      detail: [
        'tour',
        'post',
        'hierarchy'
      ]
    },
    {
      title: 'Tài chính',
      view: 'shared',
      name: 'Financial',
      type: 'financial',
      icon: 'fas fa-dollar-sign',
      apiEndpoints: [
        RESOURCE_ENDPOINTS.PLACE,
        RESOURCE_ENDPOINTS.PLACE_ENABLE,
        RESOURCE_ENDPOINTS.PLACE_LIST,
        RESOURCE_ENDPOINTS.PLACE_RATINGS,
        RESOURCE_ENDPOINTS.ARTIFACT,
        RESOURCE_ENDPOINTS.ARTIFACT_LIST,
        RESOURCE_ENDPOINTS.ARTIFACT_CLASSIFICATION,
        RESOURCE_ENDPOINTS.GROUP,
        RESOURCE_ENDPOINTS.GROUP_ITEM,
        RESOURCE_ENDPOINTS.STORAGE,
        RESOURCE_ENDPOINTS.STORAGE_LIST,
        RESOURCE_ENDPOINTS.PLACE_CATEGORIES,
        RESOURCE_ENDPOINTS.TAG,
        RESOURCE_ENDPOINTS.HIERARCHY,
        RESOURCE_ENDPOINTS.HIERARCHY_ITEM
      ],
      index: {
        titles: [{ label: 'TÀI CHÍNH', value: 'financial' }],
        columns: ['stt', 'avatar', 'name', 'organization', 'star', 'rating', 'view_count', 'created_at', 'updated_at', 'language', 'actions'],
        actions: ['showQR', 'public', 'private', 'edit', 'detail', 'booking', 'delete'],
        headerActions: ['add', 'filter', 'reset', 'synchronize', 'import', 'export'],
        excelColumns: ['id', 'name', 'ordered', 'qr_code', 'vrtour', 'description', 'content', 'status', 'price_info', 'opening_time', 'opening_day', 'location_address', 'location_longitude', 'location_latitude', 'country_id', 'area_id', 'contact_info_phone', 'contact_info_email', 'contact_info_website', 'facebook_url', 'zalo_url', 'category_id', 'tags', 'youtube_links']
      },
      show: {
        inputs: ['name', 'ordered', 'qr_code', 'vrtour', 'description', 'content'],
        leftCards: ['rating', 'artifacts', 'artifact_groups', 'groups', 'background'],
        rightCards: [
          'display',
          'price',
          'days',
          'hours',
          'address',
          'contact',
          'category',
          'tags',
          'youtube',
          'audios',
          'documents',
          'pictures',
          'videos'
        ]
      },
      detail: [
        'tour',
        'post',
        'hierarchy'
      ]
    },
    {
      title: 'Golf',
      view: 'shared',
      name: 'Golf',
      type: 'golf',
      icon: 'fas fa-golf-ball',
      apiEndpoints: [
        RESOURCE_ENDPOINTS.PLACE,
        RESOURCE_ENDPOINTS.PLACE_ENABLE,
        RESOURCE_ENDPOINTS.PLACE_LIST,
        RESOURCE_ENDPOINTS.PLACE_RATINGS,
        RESOURCE_ENDPOINTS.ARTIFACT,
        RESOURCE_ENDPOINTS.ARTIFACT_LIST,
        RESOURCE_ENDPOINTS.ARTIFACT_CLASSIFICATION,
        RESOURCE_ENDPOINTS.GROUP,
        RESOURCE_ENDPOINTS.GROUP_ITEM,
        RESOURCE_ENDPOINTS.STORAGE,
        RESOURCE_ENDPOINTS.STORAGE_LIST,
        RESOURCE_ENDPOINTS.PLACE_CATEGORIES,
        RESOURCE_ENDPOINTS.TAG,
        RESOURCE_ENDPOINTS.HIERARCHY,
        RESOURCE_ENDPOINTS.HIERARCHY_ITEM
      ],
      index: {
        titles: [{ label: 'GOLF', value: 'golf' }],
        columns: ['stt', 'avatar', 'name', 'organization', 'star', 'rating', 'view_count', 'created_at', 'updated_at', 'language', 'actions'],
        actions: ['showQR', 'public', 'private', 'edit', 'detail', 'booking', 'delete'],
        headerActions: ['add', 'filter', 'reset', 'synchronize', 'import', 'export'],
        excelColumns: ['id', 'name', 'ordered', 'qr_code', 'vrtour', 'description', 'content', 'status', 'price_info', 'opening_time', 'opening_day', 'location_address', 'location_longitude', 'location_latitude', 'country_id', 'area_id', 'contact_info_phone', 'contact_info_email', 'contact_info_website', 'facebook_url', 'zalo_url', 'category_id', 'tags', 'youtube_links']
      },
      show: {
        inputs: ['name', 'ordered', 'qr_code', 'vrtour', 'description', 'content'],
        leftCards: ['rating', 'artifacts', 'artifact_groups', 'groups', 'background'],
        rightCards: [
          'display',
          'price',
          'days',
          'hours',
          'address',
          'contact',
          'category',
          'tags',
          'youtube',
          'audios',
          'documents',
          'pictures',
          'videos'
        ]
      },
      detail: [
        'tour',
        'post',
        'hierarchy'
      ]
    },
    {
      title: 'Nhà hàng',
      view: 'shared',
      name: 'Restaurant',
      type: 'restaurant',
      icon: 'fas fa-concierge-bell',
      apiEndpoints: [
        RESOURCE_ENDPOINTS.PLACE,
        RESOURCE_ENDPOINTS.PLACE_ENABLE,
        RESOURCE_ENDPOINTS.PLACE_LIST,
        RESOURCE_ENDPOINTS.PLACE_RATINGS,
        RESOURCE_ENDPOINTS.PLACE_FACILITIES,
        RESOURCE_ENDPOINTS.PLACE_SERVICES,
        RESOURCE_ENDPOINTS.GROUP,
        RESOURCE_ENDPOINTS.GROUP_ITEM,
        RESOURCE_ENDPOINTS.DISH,
        RESOURCE_ENDPOINTS.DISH_GROUP,
        RESOURCE_ENDPOINTS.STORAGE,
        RESOURCE_ENDPOINTS.STORAGE_LIST,
        RESOURCE_ENDPOINTS.PLACE_CATEGORIES,
        RESOURCE_ENDPOINTS.TAG,
        RESOURCE_ENDPOINTS.HIERARCHY,
        RESOURCE_ENDPOINTS.HIERARCHY_ITEM
      ],
      index: {
        titles: [{ label: 'NHÀ HÀNG', value: 'restaurant' }],
        columns: ['stt', 'avatar', 'name', 'organization', 'star', 'rating', 'view_count', 'created_at', 'updated_at', 'language', 'actions'],
        actions: ['showQR', 'public', 'private', 'edit', 'detail', 'booking', 'delete'],
        headerActions: ['add', 'filter', 'reset', 'synchronize', 'cook', 'cashier', 'tag', 'import', 'export'],
        excelColumns: ['id', 'name', 'ordered', 'qr_code', 'vrtour', 'description', 'content', 'status', 'price_info', 'opening_time', 'opening_day', 'location_address', 'location_longitude', 'location_latitude', 'country_id', 'area_id', 'contact_info_phone', 'contact_info_email', 'contact_info_website', 'facebook_url', 'zalo_url', 'category_id', 'tags', 'youtube_links']
      },
      show: {
        inputs: ['name', 'ordered', 'qr_code', 'vrtour', 'description', 'content'],
        leftCards: ['rating', 'facility', 'services', 'groups', 'foods', 'food_groups', 'background'],
        rightCards: [
          'display',
          'price',
          'days',
          'hours',
          'address',
          'contact',
          'category',
          'tags',
          'youtube',
          'audios',
          'documents',
          'pictures',
          'videos'
        ]
      },
      detail: [
        'tour',
        'post',
        'hierarchy'
      ]
    },
    {
      title: 'Thương mại',
      view: 'shared',
      name: 'Trade',
      type: 'trade',
      icon: 'fas fa-concierge-bell',
      apiEndpoints: [
        RESOURCE_ENDPOINTS.PLACE,
        RESOURCE_ENDPOINTS.PLACE_ENABLE,
        RESOURCE_ENDPOINTS.PLACE_LIST,
        RESOURCE_ENDPOINTS.PLACE_RATINGS,
        RESOURCE_ENDPOINTS.PLACE_FACILITIES,
        RESOURCE_ENDPOINTS.PLACE_SERVICES,
        RESOURCE_ENDPOINTS.GROUP,
        RESOURCE_ENDPOINTS.GROUP_ITEM,
        RESOURCE_ENDPOINTS.DISH,
        RESOURCE_ENDPOINTS.DISH_GROUP,
        RESOURCE_ENDPOINTS.STORAGE,
        RESOURCE_ENDPOINTS.STORAGE_LIST,
        RESOURCE_ENDPOINTS.PLACE_CATEGORIES,
        RESOURCE_ENDPOINTS.TAG,
        RESOURCE_ENDPOINTS.HIERARCHY,
        RESOURCE_ENDPOINTS.HIERARCHY_ITEM
      ],
      index: {
        titles: [{ label: 'THƯƠNG MẠI', value: 'trade' }],
        columns: ['stt', 'avatar', 'name', 'organization', 'star', 'rating', 'view_count', 'created_at', 'updated_at', 'language', 'actions'],
        actions: ['showQR', 'public', 'private', 'edit', 'detail', 'booking', 'delete'],
        headerActions: ['add', 'filter', 'reset', 'synchronize', 'cook', 'cashier', 'tag', 'import', 'export'],
        excelColumns: ['id', 'name', 'ordered', 'qr_code', 'vrtour', 'description', 'content', 'status', 'price_info', 'opening_time', 'opening_day', 'location_address', 'location_longitude', 'location_latitude', 'country_id', 'area_id', 'contact_info_phone', 'contact_info_email', 'contact_info_website', 'facebook_url', 'zalo_url', 'category_id', 'tags', 'youtube_links']
      },
      show: {
        inputs: ['name', 'ordered', 'qr_code', 'vrtour', 'description', 'content'],
        leftCards: ['rating', 'facility', 'services', 'groups', 'foods', 'food_groups', 'background'],
        rightCards: [
          'display',
          'price',
          'days',
          'hours',
          'address',
          'contact',
          'category',
          'tags',
          'youtube',
          'audios',
          'documents',
          'pictures',
          'videos'
        ]
      },
      detail: [
        'tour',
        'post',
        'hierarchy'
      ]
    },
    {
      title: 'Làng nghề',
      view: 'shared',
      name: 'Craft-village',
      type: 'craft-village',
      icon: 'fas fa-certificate',
      apiEndpoints: [
        RESOURCE_ENDPOINTS.PLACE,
        RESOURCE_ENDPOINTS.PLACE_ENABLE,
        RESOURCE_ENDPOINTS.PLACE_LIST,
        RESOURCE_ENDPOINTS.PLACE_RATINGS,
        RESOURCE_ENDPOINTS.ARTIFACT,
        RESOURCE_ENDPOINTS.ARTIFACT_LIST,
        RESOURCE_ENDPOINTS.ARTIFACT_CLASSIFICATION,
        RESOURCE_ENDPOINTS.GROUP,
        RESOURCE_ENDPOINTS.GROUP_ITEM,
        RESOURCE_ENDPOINTS.STORAGE,
        RESOURCE_ENDPOINTS.STORAGE_LIST,
        RESOURCE_ENDPOINTS.PLACE_CATEGORIES,
        RESOURCE_ENDPOINTS.TAG,
        RESOURCE_ENDPOINTS.HIERARCHY,
        RESOURCE_ENDPOINTS.HIERARCHY_ITEM
      ],
      index: {
        titles: [{ label: 'LÀNG NGHỀ', value: 'craft-village' }],
        columns: ['stt', 'avatar', 'name', 'parent', 'organization', 'star', 'rating', 'view_count', 'created_at', 'updated_at', 'language', 'actions'],
        actions: ['copy', 'showQR', 'public', 'private', 'edit', 'detail', 'booking', 'delete'],
        headerActions: ['add', 'filter', 'reset', 'synchronize', 'import', 'export'],
        excelColumns: ['id', 'name', 'ordered', 'qr_code', 'vrtour', 'vrtour_trailer', 'description', 'content', 'navigation', 'route_map', 'status', 'price_info', 'opening_time', 'opening_day', 'location_address', 'location_longitude', 'location_latitude', 'country_id', 'area_id', 'contact_info_phone', 'contact_info_email', 'contact_info_website', 'facebook_url', 'zalo_url', 'category_id', 'tags', 'youtube_links']
      },
      show: {
        inputs: ['name', 'qr_code', 'ordered', 'vrtour', 'vrtour_trailer', 'description', 'content', 'navigation', 'route_map'],
        leftCards: ['rating', 'artifacts', 'artifact_groups', 'groups', 'background'],
        rightCards: [
          // 'packages',//
          'place_parent',
          'display',
          'price',
          'days',
          'hours',
          'address',
          'contact',
          'category',
          'tags',
          'youtube',
          'audios',
          'documents',
          'pictures',
          'videos'
        ]
      },
      detail: [
        'tour',
        'post',
        'hierarchy'
      ]
    },
    {
      title: 'Kinh nghiệm du lịch',
      view: 'shared',
      name: 'Travel-experience',
      type: 'travel-experience',
      icon: 'fas fa-suitcase-rolling',
      apiEndpoints: [
        RESOURCE_ENDPOINTS.PLACE,
        RESOURCE_ENDPOINTS.PLACE_ENABLE,
        RESOURCE_ENDPOINTS.PLACE_LIST,
        RESOURCE_ENDPOINTS.PLACE_RATINGS,
        RESOURCE_ENDPOINTS.ARTIFACT,
        RESOURCE_ENDPOINTS.ARTIFACT_LIST,
        RESOURCE_ENDPOINTS.ARTIFACT_CLASSIFICATION,
        RESOURCE_ENDPOINTS.GROUP,
        RESOURCE_ENDPOINTS.GROUP_ITEM,
        RESOURCE_ENDPOINTS.STORAGE,
        RESOURCE_ENDPOINTS.STORAGE_LIST,
        RESOURCE_ENDPOINTS.DISPLAY_MODELS,
        RESOURCE_ENDPOINTS.PLACE_CATEGORIES,
        RESOURCE_ENDPOINTS.TAG,
        RESOURCE_ENDPOINTS.HIERARCHY,
        RESOURCE_ENDPOINTS.HIERARCHY_ITEM
      ],
      index: {
        titles: [{ label: 'KINH NGHIỆM DU LỊCH', value: 'travel-experience' }],
        columns: ['stt', 'avatar', 'name', 'organization', 'star', 'rating', 'view_count', 'created_at', 'updated_at', 'language', 'actions'],
        actions: ['showQR', 'public', 'private', 'edit', 'detail', 'booking', 'delete'],
        headerActions: ['add', 'filter', 'reset', 'synchronize', 'import', 'export'],
        excelColumns: ['id', 'name', 'ordered', 'qr_code', 'vrtour', 'vrtour_trailer', 'description', 'content', 'navigation', 'route_map', 'status', 'price_info', 'opening_time', 'opening_day', 'location_address', 'location_longitude', 'location_latitude', 'country_id', 'area_id', 'contact_info_phone', 'contact_info_email', 'contact_info_website', 'facebook_url', 'zalo_url', 'category_id', 'tags', 'youtube_links']
      },
      show: {
        inputs: ['name', 'qr_code', 'ordered', 'vrtour', 'vrtour_trailer', 'description', 'content', 'navigation', 'route_map'],
        leftCards: ['rating', 'artifacts', 'artifact_groups', 'groups', 'background'],
        rightCards: [
          // 'packages',//
          'place_parent',
          'display',
          'display_model',
          'price',
          'days',
          'hours',
          'address',
          'contact',
          'category',
          'tags',
          'youtube',
          'audios',
          'documents',
          'pictures',
          'videos'
        ]
      },
      detail: [
        'tour',
        'post',
        'hierarchy'
      ]
    },
    {
      title: 'Quy Y',
      view: 'shared',
      name: 'Refuge',
      type: 'refuge',
      icon: 'fas fa-vihara',
      apiEndpoints: [
        RESOURCE_ENDPOINTS.PLACE,
        RESOURCE_ENDPOINTS.PLACE_ENABLE,
        RESOURCE_ENDPOINTS.PLACE_LIST,
        RESOURCE_ENDPOINTS.PLACE_RATINGS,
        RESOURCE_ENDPOINTS.ARTIFACT,
        RESOURCE_ENDPOINTS.ARTIFACT_LIST,
        RESOURCE_ENDPOINTS.ARTIFACT_CLASSIFICATION,
        RESOURCE_ENDPOINTS.GROUP,
        RESOURCE_ENDPOINTS.GROUP_ITEM,
        RESOURCE_ENDPOINTS.STORAGE,
        RESOURCE_ENDPOINTS.STORAGE_LIST,
        RESOURCE_ENDPOINTS.DISPLAY_MODELS,
        RESOURCE_ENDPOINTS.PLACE_CATEGORIES,
        RESOURCE_ENDPOINTS.TAG,
        RESOURCE_ENDPOINTS.HIERARCHY,
        RESOURCE_ENDPOINTS.HIERARCHY_ITEM
      ],
      index: {
        titles: [{ label: 'QUY Y', value: 'refuge' }],
        columns: ['stt', 'avatar', 'name', 'organization', 'star', 'rating', 'view_count', 'created_at', 'updated_at', 'language', 'actions'],
        actions: ['showQR', 'public', 'private', 'edit', 'detail', 'booking', 'delete'],
        headerActions: ['add', 'filter', 'reset', 'synchronize', 'import', 'export'],
        excelColumns: ['id', 'name', 'ordered', 'qr_code', 'vrtour', 'vrtour_trailer', 'description', 'content', 'navigation', 'route_map', 'status', 'price_info', 'opening_time', 'opening_day', 'location_address', 'location_longitude', 'location_latitude', 'country_id', 'area_id', 'contact_info_phone', 'contact_info_email', 'contact_info_website', 'facebook_url', 'zalo_url', 'category_id', 'tags', 'youtube_links']
      },
      show: {
        inputs: ['name', 'qr_code', 'ordered', 'vrtour', 'vrtour_trailer', 'description', 'content', 'navigation', 'route_map'],
        leftCards: ['rating', 'artifacts', 'artifact_groups', 'groups', 'background'],
        rightCards: [
          // 'packages',//
          'place_parent',
          'display',
          'display_model',
          'price',
          'days',
          'hours',
          'address',
          'contact',
          'category',
          'tags',
          'youtube',
          'audios',
          'documents',
          'pictures',
          'videos'
        ]
      },
      detail: [
        'tour',
        'post',
        'hierarchy'
      ]
    },
    {
      title: 'Hoạt động',
      view: 'shared',
      name: 'Activity',
      type: 'activity',
      icon: 'fas fa-skating',
      apiEndpoints: [
        RESOURCE_ENDPOINTS.PLACE,
        RESOURCE_ENDPOINTS.PLACE_ENABLE,
        RESOURCE_ENDPOINTS.PLACE_LIST,
        RESOURCE_ENDPOINTS.PLACE_RATINGS,
        RESOURCE_ENDPOINTS.ARTIFACT,
        RESOURCE_ENDPOINTS.ARTIFACT_LIST,
        RESOURCE_ENDPOINTS.ARTIFACT_CLASSIFICATION,
        RESOURCE_ENDPOINTS.GROUP,
        RESOURCE_ENDPOINTS.GROUP_ITEM,
        RESOURCE_ENDPOINTS.STORAGE,
        RESOURCE_ENDPOINTS.STORAGE_LIST,
        RESOURCE_ENDPOINTS.DISPLAY_MODELS,
        RESOURCE_ENDPOINTS.PLACE_CATEGORIES,
        RESOURCE_ENDPOINTS.TAG,
        RESOURCE_ENDPOINTS.HIERARCHY,
        RESOURCE_ENDPOINTS.HIERARCHY_ITEM
      ],
      index: {
        titles: [{ label: 'HOẠT ĐỘNG', value: 'activity' }],
        columns: ['stt', 'avatar', 'name', 'organization', 'star', 'rating', 'view_count', 'created_at', 'updated_at', 'language', 'actions'],
        actions: ['showQR', 'public', 'private', 'edit', 'detail', 'booking', 'delete'],
        headerActions: ['add', 'filter', 'reset', 'synchronize', 'import', 'export'],
        excelColumns: ['id', 'name', 'ordered', 'qr_code', 'vrtour', 'vrtour_trailer', 'description', 'content', 'navigation', 'route_map', 'status', 'price_info', 'opening_time', 'opening_day', 'location_address', 'location_longitude', 'location_latitude', 'country_id', 'area_id', 'contact_info_phone', 'contact_info_email', 'contact_info_website', 'facebook_url', 'zalo_url', 'category_id', 'tags', 'youtube_links']
      },
      show: {
        inputs: ['name', 'qr_code', 'ordered', 'vrtour', 'vrtour_trailer', 'description', 'content', 'navigation', 'route_map'],
        leftCards: ['rating', 'artifacts', 'artifact_groups', 'groups', 'background'],
        rightCards: [
          // 'packages',//
          'place_parent',
          'display',
          'display_model',
          'price',
          'days',
          'hours',
          'address',
          'contact',
          'category',
          'tags',
          'youtube',
          'audios',
          'documents',
          'pictures',
          'videos'
        ]
      },
      detail: [
        'tour',
        'post',
        'hierarchy'
      ]
    },
    {
      title: 'Phật học',
      view: 'shared',
      name: 'Buddhist-learning',
      type: 'buddhist-learning',
      icon: 'fas fa-dharmachakra',
      apiEndpoints: [
        RESOURCE_ENDPOINTS.PLACE,
        RESOURCE_ENDPOINTS.PLACE_ENABLE,
        RESOURCE_ENDPOINTS.PLACE_LIST,
        RESOURCE_ENDPOINTS.PLACE_RATINGS,
        RESOURCE_ENDPOINTS.ARTIFACT,
        RESOURCE_ENDPOINTS.ARTIFACT_LIST,
        RESOURCE_ENDPOINTS.ARTIFACT_CLASSIFICATION,
        RESOURCE_ENDPOINTS.GROUP,
        RESOURCE_ENDPOINTS.GROUP_ITEM,
        RESOURCE_ENDPOINTS.STORAGE,
        RESOURCE_ENDPOINTS.STORAGE_LIST,
        RESOURCE_ENDPOINTS.DISPLAY_MODELS,
        RESOURCE_ENDPOINTS.PLACE_CATEGORIES,
        RESOURCE_ENDPOINTS.TAG,
        RESOURCE_ENDPOINTS.HIERARCHY,
        RESOURCE_ENDPOINTS.HIERARCHY_ITEM
      ],
      index: {
        titles: [{ label: 'PHẬT HỌC', value: 'buddhist-learning' }],
        columns: ['stt', 'avatar', 'name', 'organization', 'star', 'rating', 'view_count', 'created_at', 'updated_at', 'language', 'actions'],
        actions: ['showQR', 'public', 'private', 'edit', 'detail', 'booking', 'delete'],
        headerActions: ['add', 'filter', 'reset', 'synchronize', 'import', 'export'],
        excelColumns: ['id', 'name', 'ordered', 'qr_code', 'vrtour', 'vrtour_trailer', 'description', 'content', 'navigation', 'route_map', 'status', 'price_info', 'opening_time', 'opening_day', 'location_address', 'location_longitude', 'location_latitude', 'country_id', 'area_id', 'contact_info_phone', 'contact_info_email', 'contact_info_website', 'facebook_url', 'zalo_url', 'category_id', 'tags', 'youtube_links']
      },
      show: {
        inputs: ['name', 'qr_code', 'ordered', 'vrtour', 'vrtour_trailer', 'description', 'content', 'navigation', 'route_map'],
        leftCards: ['rating', 'artifacts', 'artifact_groups', 'groups', 'background'],
        rightCards: [
          // 'packages',//
          'place_parent',
          'display',
          'display_model',
          'price',
          'days',
          'hours',
          'address',
          'contact',
          'category',
          'tags',
          'youtube',
          'audios',
          'documents',
          'pictures',
          'videos'
        ]
      },
      detail: [
        'tour',
        'post',
        'hierarchy'
      ]
    },
    {
      title: 'Kinh phật',
      view: 'shared',
      name: 'Buddhist-scripture',
      type: 'buddhist-scripture',
      icon: 'fas fa-om',
      apiEndpoints: [
        RESOURCE_ENDPOINTS.PLACE,
        RESOURCE_ENDPOINTS.PLACE_ENABLE,
        RESOURCE_ENDPOINTS.PLACE_LIST,
        RESOURCE_ENDPOINTS.PLACE_RATINGS,
        RESOURCE_ENDPOINTS.ARTIFACT,
        RESOURCE_ENDPOINTS.ARTIFACT_LIST,
        RESOURCE_ENDPOINTS.ARTIFACT_CLASSIFICATION,
        RESOURCE_ENDPOINTS.GROUP,
        RESOURCE_ENDPOINTS.GROUP_ITEM,
        RESOURCE_ENDPOINTS.STORAGE,
        RESOURCE_ENDPOINTS.STORAGE_LIST,
        RESOURCE_ENDPOINTS.DISPLAY_MODELS,
        RESOURCE_ENDPOINTS.PLACE_CATEGORIES,
        RESOURCE_ENDPOINTS.TAG,
        RESOURCE_ENDPOINTS.HIERARCHY,
        RESOURCE_ENDPOINTS.HIERARCHY_ITEM
      ],
      index: {
        titles: [{ label: 'KINH PHẬT', value: 'buddhist-scripture' }],
        columns: ['stt', 'avatar', 'name', 'organization', 'star', 'rating', 'view_count', 'created_at', 'updated_at', 'language', 'actions'],
        actions: ['showQR', 'public', 'private', 'edit', 'detail', 'booking', 'delete'],
        headerActions: ['add', 'filter', 'reset', 'synchronize', 'import', 'export'],
        excelColumns: ['id', 'name', 'ordered', 'qr_code', 'vrtour', 'vrtour_trailer', 'description', 'content', 'navigation', 'route_map', 'status', 'price_info', 'opening_time', 'opening_day', 'location_address', 'location_longitude', 'location_latitude', 'country_id', 'area_id', 'contact_info_phone', 'contact_info_email', 'contact_info_website', 'facebook_url', 'zalo_url', 'category_id', 'tags', 'youtube_links']
      },
      show: {
        inputs: ['name', 'qr_code', 'ordered', 'vrtour', 'vrtour_trailer', 'description', 'content', 'navigation', 'route_map'],
        leftCards: ['rating', 'artifacts', 'artifact_groups', 'groups', 'background'],
        rightCards: [
          // 'packages',//
          'place_parent',
          'display',
          'display_model',
          'price',
          'days',
          'hours',
          'address',
          'contact',
          'category',
          'tags',
          'youtube',
          'audios',
          'documents',
          'pictures',
          'videos'
        ]
      },
      detail: [
        'tour',
        'post',
        'hierarchy'
      ]
    },
    {
      title: 'Giáo hội',
      view: 'shared',
      name: 'Church',
      type: 'church',
      icon: 'fas fa-church',
      apiEndpoints: [
        RESOURCE_ENDPOINTS.PLACE,
        RESOURCE_ENDPOINTS.PLACE_ENABLE,
        RESOURCE_ENDPOINTS.PLACE_LIST,
        RESOURCE_ENDPOINTS.PLACE_RATINGS,
        RESOURCE_ENDPOINTS.ARTIFACT,
        RESOURCE_ENDPOINTS.ARTIFACT_LIST,
        RESOURCE_ENDPOINTS.ARTIFACT_CLASSIFICATION,
        RESOURCE_ENDPOINTS.GROUP,
        RESOURCE_ENDPOINTS.GROUP_ITEM,
        RESOURCE_ENDPOINTS.STORAGE,
        RESOURCE_ENDPOINTS.STORAGE_LIST,
        RESOURCE_ENDPOINTS.DISPLAY_MODELS,
        RESOURCE_ENDPOINTS.PLACE_CATEGORIES,
        RESOURCE_ENDPOINTS.TAG,
        RESOURCE_ENDPOINTS.HIERARCHY,
        RESOURCE_ENDPOINTS.HIERARCHY_ITEM
      ],
      index: {
        titles: [{ label: 'GIÁO HỘI', value: 'church' }],
        columns: ['stt', 'avatar', 'name', 'organization', 'star', 'rating', 'view_count', 'created_at', 'updated_at', 'language', 'actions'],
        actions: ['showQR', 'public', 'private', 'edit', 'detail', 'booking', 'delete'],
        headerActions: ['add', 'filter', 'reset', 'synchronize', 'import', 'export'],
        excelColumns: ['id', 'name', 'ordered', 'qr_code', 'vrtour', 'vrtour_trailer', 'description', 'content', 'navigation', 'route_map', 'status', 'price_info', 'opening_time', 'opening_day', 'location_address', 'location_longitude', 'location_latitude', 'country_id', 'area_id', 'contact_info_phone', 'contact_info_email', 'contact_info_website', 'facebook_url', 'zalo_url', 'category_id', 'tags', 'youtube_links']
      },
      show: {
        inputs: ['name', 'qr_code', 'ordered', 'vrtour', 'vrtour_trailer', 'description', 'content', 'navigation', 'route_map'],
        leftCards: ['rating', 'artifacts', 'artifact_groups', 'groups', 'background'],
        rightCards: [
          // 'packages',//
          'place_parent',
          'display',
          'display_model',
          'price',
          'days',
          'hours',
          'address',
          'contact',
          'category',
          'tags',
          'youtube',
          'audios',
          'documents',
          'pictures',
          'videos'
        ]
      },
      detail: [
        'tour',
        'post',
        'hierarchy'
      ]
    },
    {
      title: 'Thiện nguyện',
      view: 'shared',
      name: 'Volunteer',
      type: 'volunteer',
      icon: 'fas fa-hands-helping',
      apiEndpoints: [
        RESOURCE_ENDPOINTS.PLACE,
        RESOURCE_ENDPOINTS.PLACE_ENABLE,
        RESOURCE_ENDPOINTS.PLACE_LIST,
        RESOURCE_ENDPOINTS.PLACE_RATINGS,
        RESOURCE_ENDPOINTS.ARTIFACT,
        RESOURCE_ENDPOINTS.ARTIFACT_LIST,
        RESOURCE_ENDPOINTS.ARTIFACT_CLASSIFICATION,
        RESOURCE_ENDPOINTS.GROUP,
        RESOURCE_ENDPOINTS.GROUP_ITEM,
        RESOURCE_ENDPOINTS.STORAGE,
        RESOURCE_ENDPOINTS.STORAGE_LIST,
        RESOURCE_ENDPOINTS.DISPLAY_MODELS,
        RESOURCE_ENDPOINTS.PLACE_CATEGORIES,
        RESOURCE_ENDPOINTS.TAG,
        RESOURCE_ENDPOINTS.HIERARCHY,
        RESOURCE_ENDPOINTS.HIERARCHY_ITEM
      ],
      index: {
        titles: [{ label: 'THIỆN NGUYỆN', value: 'volunteer' }],
        columns: ['stt', 'avatar', 'name', 'organization', 'star', 'rating', 'view_count', 'created_at', 'updated_at', 'language', 'actions'],
        actions: ['showQR', 'public', 'private', 'edit', 'detail', 'booking', 'delete'],
        headerActions: ['add', 'filter', 'reset', 'synchronize', 'import', 'export'],
        excelColumns: ['id', 'name', 'ordered', 'qr_code', 'vrtour', 'vrtour_trailer', 'description', 'content', 'navigation', 'route_map', 'status', 'price_info', 'opening_time', 'opening_day', 'location_address', 'location_longitude', 'location_latitude', 'country_id', 'area_id', 'contact_info_phone', 'contact_info_email', 'contact_info_website', 'facebook_url', 'zalo_url', 'category_id', 'tags', 'youtube_links']
      },
      show: {
        inputs: ['name', 'qr_code', 'ordered', 'vrtour', 'vrtour_trailer', 'description', 'content', 'navigation', 'route_map'],
        leftCards: ['rating', 'artifacts', 'artifact_groups', 'groups', 'background'],
        rightCards: [
          // 'packages',//
          'place_parent',
          'display',
          'display_model',
          'price',
          'days',
          'hours',
          'address',
          'contact',
          'category',
          'tags',
          'youtube',
          'audios',
          'documents',
          'pictures',
          'videos'
        ]
      },
      detail: [
        'tour',
        'post',
        'hierarchy'
      ]
    },
    {
      title: 'Nghĩa trang',
      view: 'shared',
      name: 'Cemetery',
      type: 'cemetery',
      icon: 'fas fa-synagogue',
      apiEndpoints: [
        RESOURCE_ENDPOINTS.PLACE,
        RESOURCE_ENDPOINTS.PLACE_ENABLE,
        RESOURCE_ENDPOINTS.PLACE_LIST,
        RESOURCE_ENDPOINTS.PLACE_RATINGS,
        RESOURCE_ENDPOINTS.ARTIFACT,
        RESOURCE_ENDPOINTS.ARTIFACT_LIST,
        RESOURCE_ENDPOINTS.ARTIFACT_CLASSIFICATION,
        RESOURCE_ENDPOINTS.GROUP,
        RESOURCE_ENDPOINTS.GROUP_ITEM,
        RESOURCE_ENDPOINTS.STORAGE,
        RESOURCE_ENDPOINTS.STORAGE_LIST,
        RESOURCE_ENDPOINTS.DISPLAY_MODELS,
        RESOURCE_ENDPOINTS.PLACE_CATEGORIES,
        RESOURCE_ENDPOINTS.TAG,
        RESOURCE_ENDPOINTS.HIERARCHY,
        RESOURCE_ENDPOINTS.HIERARCHY_ITEM
      ],
      index: {
        titles: [{ label: 'NGHĨA TRANG', value: 'cemetery' }],
        columns: ['stt', 'avatar', 'name', 'organization', 'star', 'rating', 'view_count', 'created_at', 'updated_at', 'language', 'actions'],
        actions: ['showQR', 'public', 'private', 'edit', 'detail', 'booking', 'delete'],
        headerActions: ['add', 'filter', 'reset', 'synchronize', 'import', 'export'],
        excelColumns: ['id', 'name', 'ordered', 'qr_code', 'vrtour', 'vrtour_trailer', 'description', 'content', 'navigation', 'route_map', 'status', 'price_info', 'opening_time', 'opening_day', 'location_address', 'location_longitude', 'location_latitude', 'country_id', 'area_id', 'contact_info_phone', 'contact_info_email', 'contact_info_website', 'facebook_url', 'zalo_url', 'category_id', 'tags', 'youtube_links']
      },
      show: {
        inputs: ['name', 'qr_code', 'ordered', 'vrtour', 'vrtour_trailer', 'description', 'content', 'navigation', 'route_map'],
        leftCards: ['rating', 'artifacts', 'artifact_groups', 'groups', 'background'],
        rightCards: [
          // 'packages',//
          'place_parent',
          'display',
          'display_model',
          'price',
          'days',
          'hours',
          'address',
          'contact',
          'category',
          'tags',
          'youtube',
          'audios',
          'documents',
          'pictures',
          'videos'
        ]
      },
      detail: [
        'tour',
        'post',
        'hierarchy'
      ]
    },
    {
      title: 'Hỏi đáp',
      view: 'shared',
      name: 'Qna',
      type: 'qna',
      icon: 'fas fa-question',
      apiEndpoints: [
        RESOURCE_ENDPOINTS.PLACE,
        RESOURCE_ENDPOINTS.PLACE_ENABLE,
        RESOURCE_ENDPOINTS.PLACE_LIST,
        RESOURCE_ENDPOINTS.PLACE_RATINGS,
        RESOURCE_ENDPOINTS.ARTIFACT,
        RESOURCE_ENDPOINTS.ARTIFACT_LIST,
        RESOURCE_ENDPOINTS.ARTIFACT_CLASSIFICATION,
        RESOURCE_ENDPOINTS.GROUP,
        RESOURCE_ENDPOINTS.GROUP_ITEM,
        RESOURCE_ENDPOINTS.STORAGE,
        RESOURCE_ENDPOINTS.STORAGE_LIST,
        RESOURCE_ENDPOINTS.DISPLAY_MODELS,
        RESOURCE_ENDPOINTS.PLACE_CATEGORIES,
        RESOURCE_ENDPOINTS.TAG,
        RESOURCE_ENDPOINTS.HIERARCHY,
        RESOURCE_ENDPOINTS.HIERARCHY_ITEM
      ],
      index: {
        titles: [{ label: 'HỎI ĐÁP', value: 'qna' }],
        columns: ['stt', 'avatar', 'name', 'organization', 'star', 'rating', 'view_count', 'created_at', 'updated_at', 'language', 'actions'],
        actions: ['showQR', 'public', 'private', 'edit', 'detail', 'booking', 'delete'],
        headerActions: ['add', 'filter', 'reset', 'synchronize', 'import', 'export'],
        excelColumns: ['id', 'name', 'ordered', 'qr_code', 'description', 'content', 'status', 'price_info', 'opening_time', 'opening_day', 'location_address', 'location_longitude', 'location_latitude', 'country_id', 'area_id', 'contact_info_phone', 'contact_info_email', 'contact_info_website', 'facebook_url', 'zalo_url', 'category_id', 'tags', 'youtube_links']
      },
      show: {
        inputs: ['name', 'qr_code', 'ordered', 'description', 'content'],
        leftCards: ['rating', 'artifacts', 'artifact_groups', 'groups', 'background'],
        rightCards: [
          // 'packages',//
          'place_parent',
          'display',
          'display_model',
          'price',
          'days',
          'hours',
          'address',
          'contact',
          'category',
          'tags',
          'youtube',
          'audios',
          'documents',
          'pictures',
          'videos'
        ]
      },
      detail: [
        'tour',
        'post',
        'hierarchy'
      ]
    },
    {
      title: 'Bảo tàng video',
      view: 'shared',
      name: 'Video-library',
      type: 'video-library',
      icon: 'fas fa-video',
      apiEndpoints: [
        RESOURCE_ENDPOINTS.PLACE,
        RESOURCE_ENDPOINTS.PLACE_ENABLE,
        RESOURCE_ENDPOINTS.PLACE_LIST,
        RESOURCE_ENDPOINTS.PLACE_RATINGS,
        RESOURCE_ENDPOINTS.ARTIFACT,
        RESOURCE_ENDPOINTS.ARTIFACT_LIST,
        RESOURCE_ENDPOINTS.ARTIFACT_CLASSIFICATION,
        RESOURCE_ENDPOINTS.GROUP,
        RESOURCE_ENDPOINTS.GROUP_ITEM,
        RESOURCE_ENDPOINTS.STORAGE,
        RESOURCE_ENDPOINTS.STORAGE_LIST,
        RESOURCE_ENDPOINTS.DISPLAY_MODELS,
        RESOURCE_ENDPOINTS.PLACE_CATEGORIES,
        RESOURCE_ENDPOINTS.TAG,
        RESOURCE_ENDPOINTS.HIERARCHY,
        RESOURCE_ENDPOINTS.HIERARCHY_ITEM
      ],
      index: {
        titles: [{ label: 'BẢO TÀNG VIDEO', value: 'video-library' }],
        columns: ['stt', 'avatar', 'name', 'organization', 'star', 'rating', 'view_count', 'created_at', 'updated_at', 'language', 'actions'],
        actions: ['showQR', 'public', 'private', 'edit', 'detail', 'booking', 'delete'],
        headerActions: ['add', 'filter', 'reset', 'synchronize', 'import', 'export'],
        excelColumns: ['id', 'name', 'ordered', 'qr_code', 'vrtour', 'vrtour_trailer', 'description', 'content', 'navigation', 'route_map', 'status', 'price_info', 'opening_time', 'opening_day', 'location_address', 'location_longitude', 'location_latitude', 'country_id', 'area_id', 'contact_info_phone', 'contact_info_email', 'contact_info_website', 'facebook_url', 'zalo_url', 'category_id', 'tags', 'youtube_links']
      },
      show: {
        inputs: ['name', 'qr_code', 'ordered', 'vrtour', 'vrtour_trailer', 'description', 'content', 'navigation', 'route_map'],
        leftCards: ['rating', 'artifacts', 'artifact_groups', 'groups', 'background'],
        rightCards: [
          // 'packages',//
          'place_parent',
          'display',
          'display_model',
          'price',
          'days',
          'hours',
          'address',
          'contact',
          'category',
          'tags',
          'youtube',
          'audios',
          'documents',
          'pictures',
          'videos'
        ]
      },
      detail: [
        'tour',
        'post',
        'hierarchy'
      ]
    },
    {
      title: 'Bảo tàng âm thanh',
      view: 'shared',
      name: 'Sound-library',
      type: 'sound-library',
      icon: 'fas fa-volume-up',
      apiEndpoints: [
        RESOURCE_ENDPOINTS.PLACE,
        RESOURCE_ENDPOINTS.PLACE_ENABLE,
        RESOURCE_ENDPOINTS.PLACE_LIST,
        RESOURCE_ENDPOINTS.PLACE_RATINGS,
        RESOURCE_ENDPOINTS.ARTIFACT,
        RESOURCE_ENDPOINTS.ARTIFACT_LIST,
        RESOURCE_ENDPOINTS.ARTIFACT_CLASSIFICATION,
        RESOURCE_ENDPOINTS.GROUP,
        RESOURCE_ENDPOINTS.GROUP_ITEM,
        RESOURCE_ENDPOINTS.STORAGE,
        RESOURCE_ENDPOINTS.STORAGE_LIST,
        RESOURCE_ENDPOINTS.DISPLAY_MODELS,
        RESOURCE_ENDPOINTS.PLACE_CATEGORIES,
        RESOURCE_ENDPOINTS.TAG,
        RESOURCE_ENDPOINTS.HIERARCHY,
        RESOURCE_ENDPOINTS.HIERARCHY_ITEM
      ],
      index: {
        titles: [{ label: 'BẢO TÀNG ÂM THANH', value: 'sound-library' }],
        columns: ['stt', 'avatar', 'name', 'organization', 'star', 'rating', 'view_count', 'created_at', 'updated_at', 'language', 'actions'],
        actions: ['showQR', 'public', 'private', 'edit', 'detail', 'booking', 'delete'],
        headerActions: ['add', 'filter', 'reset', 'synchronize', 'import', 'export'],
        excelColumns: ['id', 'name', 'ordered', 'qr_code', 'vrtour', 'vrtour_trailer', 'description', 'content', 'navigation', 'route_map', 'status', 'price_info', 'opening_time', 'opening_day', 'location_address', 'location_longitude', 'location_latitude', 'country_id', 'area_id', 'contact_info_phone', 'contact_info_email', 'contact_info_website', 'facebook_url', 'zalo_url', 'category_id', 'tags', 'youtube_links']
      },
      show: {
        inputs: ['name', 'qr_code', 'ordered', 'vrtour', 'vrtour_trailer', 'description', 'content', 'navigation', 'route_map'],
        leftCards: ['rating', 'artifacts', 'artifact_groups', 'groups', 'background'],
        rightCards: [
          // 'packages',//
          'place_parent',
          'display',
          'display_model',
          'price',
          'days',
          'hours',
          'address',
          'contact',
          'category',
          'tags',
          'youtube',
          'audios',
          'documents',
          'pictures',
          'videos'
        ]
      },
      detail: [
        'tour',
        'post',
        'hierarchy'
      ]
    },
    {
      title: 'Bảo tàng tài liệu',
      view: 'shared',
      name: 'Document-library',
      type: 'document-library',
      icon: 'fas fa-book',
      apiEndpoints: [
        RESOURCE_ENDPOINTS.PLACE,
        RESOURCE_ENDPOINTS.PLACE_ENABLE,
        RESOURCE_ENDPOINTS.PLACE_LIST,
        RESOURCE_ENDPOINTS.PLACE_RATINGS,
        RESOURCE_ENDPOINTS.ARTIFACT,
        RESOURCE_ENDPOINTS.ARTIFACT_LIST,
        RESOURCE_ENDPOINTS.ARTIFACT_CLASSIFICATION,
        RESOURCE_ENDPOINTS.GROUP,
        RESOURCE_ENDPOINTS.GROUP_ITEM,
        RESOURCE_ENDPOINTS.STORAGE,
        RESOURCE_ENDPOINTS.STORAGE_LIST,
        RESOURCE_ENDPOINTS.DISPLAY_MODELS,
        RESOURCE_ENDPOINTS.PLACE_CATEGORIES,
        RESOURCE_ENDPOINTS.TAG,
        RESOURCE_ENDPOINTS.HIERARCHY,
        RESOURCE_ENDPOINTS.HIERARCHY_ITEM
      ],
      index: {
        titles: [{ label: 'BẢO TÀNG TÀI LIỆU', value: 'document-library' }],
        columns: ['stt', 'avatar', 'name', 'organization', 'star', 'rating', 'view_count', 'created_at', 'updated_at', 'language', 'actions'],
        actions: ['showQR', 'public', 'private', 'edit', 'detail', 'booking', 'delete'],
        headerActions: ['add', 'filter', 'reset', 'synchronize', 'import', 'export'],
        excelColumns: ['id', 'name', 'ordered', 'qr_code', 'vrtour', 'vrtour_trailer', 'description', 'content', 'navigation', 'route_map', 'status', 'price_info', 'opening_time', 'opening_day', 'location_address', 'location_longitude', 'location_latitude', 'country_id', 'area_id', 'contact_info_phone', 'contact_info_email', 'contact_info_website', 'facebook_url', 'zalo_url', 'category_id', 'tags', 'youtube_links']
      },
      show: {
        inputs: ['name', 'qr_code', 'ordered', 'vrtour', 'vrtour_trailer', 'description', 'content', 'navigation', 'route_map'],
        leftCards: ['rating', 'artifacts', 'artifact_groups', 'groups', 'background'],
        rightCards: [
          // 'packages',//
          'place_parent',
          'display',
          'display_model',
          'price',
          'days',
          'hours',
          'address',
          'contact',
          'category',
          'tags',
          'youtube',
          'audios',
          'documents',
          'pictures',
          'videos'
        ]
      },
      detail: [
        'tour',
        'post',
        'hierarchy'
      ]
    },
    {
      title: 'Bảo tàng hình ảnh',
      view: 'shared',
      name: 'Image-library',
      type: 'image-library',
      icon: 'fas fa-image',
      apiEndpoints: [
        RESOURCE_ENDPOINTS.PLACE,
        RESOURCE_ENDPOINTS.PLACE_ENABLE,
        RESOURCE_ENDPOINTS.PLACE_LIST,
        RESOURCE_ENDPOINTS.PLACE_RATINGS,
        RESOURCE_ENDPOINTS.ARTIFACT,
        RESOURCE_ENDPOINTS.ARTIFACT_LIST,
        RESOURCE_ENDPOINTS.ARTIFACT_CLASSIFICATION,
        RESOURCE_ENDPOINTS.GROUP,
        RESOURCE_ENDPOINTS.GROUP_ITEM,
        RESOURCE_ENDPOINTS.STORAGE,
        RESOURCE_ENDPOINTS.STORAGE_LIST,
        RESOURCE_ENDPOINTS.DISPLAY_MODELS,
        RESOURCE_ENDPOINTS.PLACE_CATEGORIES,
        RESOURCE_ENDPOINTS.TAG,
        RESOURCE_ENDPOINTS.HIERARCHY,
        RESOURCE_ENDPOINTS.HIERARCHY_ITEM
      ],
      index: {
        titles: [{ label: 'BẢO TÀNG HÌNH ẢNH', value: 'image-library' }],
        columns: ['stt', 'avatar', 'name', 'organization', 'star', 'rating', 'view_count', 'created_at', 'updated_at', 'language', 'actions'],
        actions: ['showQR', 'public', 'private', 'edit', 'detail', 'booking', 'delete'],
        headerActions: ['add', 'filter', 'reset', 'synchronize', 'import', 'export'],
        excelColumns: ['id', 'name', 'ordered', 'qr_code', 'vrtour', 'vrtour_trailer', 'description', 'content', 'navigation', 'route_map', 'status', 'price_info', 'opening_time', 'opening_day', 'location_address', 'location_longitude', 'location_latitude', 'country_id', 'area_id', 'contact_info_phone', 'contact_info_email', 'contact_info_website', 'facebook_url', 'zalo_url', 'category_id', 'tags', 'youtube_links']
      },
      show: {
        inputs: ['name', 'qr_code', 'ordered', 'vrtour', 'vrtour_trailer', 'description', 'content', 'navigation', 'route_map'],
        leftCards: ['rating', 'artifacts', 'artifact_groups', 'groups', 'background'],
        rightCards: [
          // 'packages',//
          'place_parent',
          'display',
          'display_model',
          'price',
          'days',
          'hours',
          'address',
          'contact',
          'category',
          'tags',
          'youtube',
          'audios',
          'documents',
          'pictures',
          'videos'
        ]
      },
      detail: [
        'tour',
        'post',
        'hierarchy'
      ]
    },
    {
      title: 'Dịch vụ khác',
      view: 'shared',
      name: 'Other',
      type: 'other',
      icon: 'fas fa-align-justify',
      apiEndpoints: [
        RESOURCE_ENDPOINTS.PLACE,
        RESOURCE_ENDPOINTS.PLACE_ENABLE,
        RESOURCE_ENDPOINTS.PLACE_LIST,
        RESOURCE_ENDPOINTS.PLACE_RATINGS,
        RESOURCE_ENDPOINTS.ARTIFACT,
        RESOURCE_ENDPOINTS.ARTIFACT_LIST,
        RESOURCE_ENDPOINTS.ARTIFACT_CLASSIFICATION,
        RESOURCE_ENDPOINTS.GROUP,
        RESOURCE_ENDPOINTS.GROUP_ITEM,
        RESOURCE_ENDPOINTS.STORAGE,
        RESOURCE_ENDPOINTS.STORAGE_LIST,
        RESOURCE_ENDPOINTS.PLACE_CATEGORIES,
        RESOURCE_ENDPOINTS.TAG,
        RESOURCE_ENDPOINTS.HIERARCHY,
        RESOURCE_ENDPOINTS.HIERARCHY_ITEM
      ],
      index: {
        titles: [{ label: 'DỊCH VỤ KHÁC', value: 'other' }],
        columns: ['stt', 'avatar', 'name', 'organization', 'star', 'rating', 'view_count', 'created_at', 'updated_at', 'language', 'actions'],
        actions: ['showQR', 'public', 'private', 'edit', 'detail', 'booking', 'delete'],
        headerActions: ['add', 'filter', 'reset', 'synchronize', 'import', 'export'],
        excelColumns: ['id', 'name', 'ordered', 'qr_code', 'vrtour', 'description', 'content', 'status', 'price_info', 'opening_time', 'opening_day', 'location_address', 'location_longitude', 'location_latitude', 'country_id', 'area_id', 'contact_info_phone', 'contact_info_email', 'contact_info_website', 'facebook_url', 'zalo_url', 'category_id', 'tags', 'youtube_links']
      },
      show: {
        inputs: ['name', 'ordered', 'qr_code', 'vrtour', 'description', 'content'],
        leftCards: ['rating', 'artifacts', 'artifact_groups', 'groups', 'background'],
        rightCards: [
          'display',
          'price',
          'days',
          'hours',
          'address',
          'contact',
          'category',
          'tags',
          'youtube',
          'audios',
          'documents',
          'pictures',
          'videos'
        ]
      },
      detail: [
        'tour',
        'post',
        'hierarchy'
      ]
    },
    {
      title: 'Chương trình KM',
      view: 'shared',
      name: 'Campaign',
      type: 'campaign',
      icon: 'fab fa-cuttlefish',
      apiEndpoints: [
        RESOURCE_ENDPOINTS.PLACE,
        RESOURCE_ENDPOINTS.PLACE_ENABLE,
        RESOURCE_ENDPOINTS.PLACE_LIST,
        RESOURCE_ENDPOINTS.PLACE_RATINGS,
        RESOURCE_ENDPOINTS.ARTIFACT,
        RESOURCE_ENDPOINTS.ARTIFACT_LIST,
        RESOURCE_ENDPOINTS.ARTIFACT_CLASSIFICATION,
        RESOURCE_ENDPOINTS.GROUP,
        RESOURCE_ENDPOINTS.GROUP_ITEM,
        RESOURCE_ENDPOINTS.PLACE_CATEGORIES,
        RESOURCE_ENDPOINTS.TAG,
        RESOURCE_ENDPOINTS.STORAGE,
        RESOURCE_ENDPOINTS.STORAGE_LIST
      ],
      index: {
        titles: [{ label: 'CHƯƠNG TRÌNH KHUYẾN MẠI', value: 'campaign' }],
        columns: ['stt', 'cam_avatar', 'cam_name', 'organization', 'star', 'rating', 'view_count', 'created_at', 'updated_at', 'language', 'actions'],
        actions: ['showQR', 'public', 'private', 'edit', 'delete'],
        headerActions: ['add', 'filter', 'reset', 'synchronize', 'import', 'export'],
        excelColumns: ['id', 'name', 'ordered', 'qr_code', 'vrtour', 'vrtour_trailer', 'description', 'content', 'status', 'price_info', 'location_address', 'location_longitude', 'location_latitude', 'country_id', 'area_id', 'contact_info_phone', 'contact_info_email', 'contact_info_website', 'facebook_url', 'zalo_url', 'category_id', 'tags', 'youtube_links']
      },
      show: {
        inputs: ['cam_name', 'ordered', 'qr_code', 'vrtour', 'vrtour_trailer', 'description', 'content'],
        leftCards: ['rating', 'artifacts', 'artifact_groups', 'groups'],
        rightCards: [
          'display',
          'price',
          'address',
          'contact',
          'category',
          'tags',
          'youtube',
          'audios',
          'documents',
          'pictures',
          'videos'
        ]
      }
    },
    {
      title: 'Bài viết Blog - chia sẻ',
      view: 'shared',
      name: 'Post',
      type: 'post',
      icon: 'fas fa-file',
      apiEndpoints: [
        RESOURCE_ENDPOINTS.PLACE,
        RESOURCE_ENDPOINTS.PLACE_ENABLE,
        RESOURCE_ENDPOINTS.PLACE_LIST,
        RESOURCE_ENDPOINTS.ARTIFACT,
        RESOURCE_ENDPOINTS.ARTIFACT_LIST,
        RESOURCE_ENDPOINTS.ARTIFACT_CLASSIFICATION,
        RESOURCE_ENDPOINTS.GROUP,
        RESOURCE_ENDPOINTS.GROUP_ITEM,
        RESOURCE_ENDPOINTS.DISPLAY_MODELS,
        RESOURCE_ENDPOINTS.PLACE_CATEGORIES,
        RESOURCE_ENDPOINTS.TAG,
        RESOURCE_ENDPOINTS.STORAGE,
        RESOURCE_ENDPOINTS.STORAGE_LIST,
        RESOURCE_ENDPOINTS.HIERARCHY,
        RESOURCE_ENDPOINTS.HIERARCHY_ITEM
      ],
      index: {
        titles: [{ label: 'BÀI VIẾT BLOG - CHIA SẺ', value: 'post' }],
        columns: ['stt', 'avatar', 'name', 'parent', 'organization', 'star', 'rating', 'view_count', 'created_at', 'updated_at', 'language', 'actions'],
        actions: ['showQR', 'public', 'private', 'edit', 'detail', 'booking', 'delete'],
        headerActions: ['add', 'filter', 'reset', 'synchronize', 'import', 'export'],
        excelColumns: ['id', 'name', 'ordered', 'qr_code', 'vrtour', 'vrtour_trailer', 'description', 'content', 'navigation', 'route_map', 'status', 'category_id', 'tags', 'youtube_links']
      },
      show: {
        inputs: ['name', 'qr_code', 'ordered', 'vrtour', 'vrtour_trailer', 'description', 'content', 'navigation', 'route_map'],
        leftCards: ['artifacts', 'artifact_groups', 'groups'],
        rightCards: [
          'display',
          'display_model',
          'address',
          'contact',
          'place',
          'category',
          'tags',
          'youtube',
          'audios',
          'documents',
          'pictures',
          'videos'
        ]
      },
      detail: [
        'tour',
        'post',
        'hierarchy'
      ]
    },
    {
      title: 'Báo Chí',
      view: 'shared',
      name: 'Press',
      type: 'press',
      icon: 'fas fa-newspaper',
      apiEndpoints: [
        RESOURCE_ENDPOINTS.PLACE,
        RESOURCE_ENDPOINTS.PLACE_ENABLE,
        RESOURCE_ENDPOINTS.PLACE_LIST,
        RESOURCE_ENDPOINTS.ARTIFACT,
        RESOURCE_ENDPOINTS.ARTIFACT_LIST,
        RESOURCE_ENDPOINTS.ARTIFACT_CLASSIFICATION,
        RESOURCE_ENDPOINTS.GROUP,
        RESOURCE_ENDPOINTS.GROUP_ITEM,
        RESOURCE_ENDPOINTS.DISPLAY_MODELS,
        RESOURCE_ENDPOINTS.PLACE_CATEGORIES,
        RESOURCE_ENDPOINTS.TAG,
        RESOURCE_ENDPOINTS.STORAGE,
        RESOURCE_ENDPOINTS.STORAGE_LIST,
        RESOURCE_ENDPOINTS.HIERARCHY,
        RESOURCE_ENDPOINTS.HIERARCHY_ITEM
      ],
      index: {
        titles: [{ label: 'BÁO CHÍ', value: 'press' }],
        columns: ['stt', 'avatar', 'name', 'parent', 'organization', 'star', 'rating', 'view_count', 'created_at', 'updated_at', 'language', 'actions'],
        actions: ['showQR', 'public', 'private', 'edit', 'detail', 'booking', 'delete'],
        headerActions: ['add', 'filter', 'reset', 'synchronize', 'import', 'export'],
        excelColumns: ['id', 'name', 'ordered', 'qr_code', 'vrtour', 'vrtour_trailer', 'description', 'content', 'navigation', 'route_map', 'status', 'category_id', 'tags', 'youtube_links']
      },
      show: {
        inputs: ['name', 'qr_code', 'ordered', 'vrtour', 'vrtour_trailer', 'description', 'content', 'navigation', 'route_map'],
        leftCards: ['artifacts', 'artifact_groups', 'groups'],
        rightCards: [
          'display',
          'display_model',
          'address',
          'contact',
          'place',
          'category',
          'tags',
          'youtube',
          'audios',
          'documents',
          'pictures',
          'videos'
        ]
      },
      detail: [
        'tour',
        'post',
        'hierarchy'
      ]
    },
    {
      title: 'Truyền thông chính sách',
      view: 'shared',
      name: 'Policy-communication',
      type: 'policy-communication',
      icon: 'fas fa-bullhorn',
      apiEndpoints: [
        RESOURCE_ENDPOINTS.PLACE,
        RESOURCE_ENDPOINTS.PLACE_ENABLE,
        RESOURCE_ENDPOINTS.PLACE_LIST,
        RESOURCE_ENDPOINTS.ARTIFACT,
        RESOURCE_ENDPOINTS.ARTIFACT_LIST,
        RESOURCE_ENDPOINTS.ARTIFACT_CLASSIFICATION,
        RESOURCE_ENDPOINTS.GROUP,
        RESOURCE_ENDPOINTS.GROUP_ITEM,
        RESOURCE_ENDPOINTS.DISPLAY_MODELS,
        RESOURCE_ENDPOINTS.PLACE_CATEGORIES,
        RESOURCE_ENDPOINTS.TAG,
        RESOURCE_ENDPOINTS.STORAGE,
        RESOURCE_ENDPOINTS.STORAGE_LIST,
        RESOURCE_ENDPOINTS.HIERARCHY,
        RESOURCE_ENDPOINTS.HIERARCHY_ITEM
      ],
      index: {
        titles: [{ label: 'TRUYỀN THÔNG CHÍNH SÁCH', value: 'policy-communication' }],
        columns: ['stt', 'avatar', 'name', 'parent', 'organization', 'star', 'rating', 'view_count', 'created_at', 'updated_at', 'language', 'actions'],
        actions: ['showQR', 'public', 'private', 'edit', 'detail', 'booking', 'delete'],
        headerActions: ['add', 'filter', 'reset', 'synchronize', 'import', 'export'],
        excelColumns: ['id', 'name', 'ordered', 'qr_code', 'vrtour', 'vrtour_trailer', 'description', 'content', 'navigation', 'route_map', 'status', 'category_id', 'tags', 'youtube_links']
      },
      show: {
        inputs: ['name', 'qr_code', 'ordered', 'vrtour', 'vrtour_trailer', 'description', 'content', 'navigation', 'route_map'],
        leftCards: ['artifacts', 'artifact_groups', 'groups'],
        rightCards: [
          'display',
          'display_model',
          'address',
          'contact',
          'place',
          'category',
          'tags',
          'youtube',
          'audios',
          'documents',
          'pictures',
          'videos'
        ]
      },
      detail: [
        'tour',
        'post',
        'hierarchy'
      ]
    },
    {
      title: 'Tour du lịch mẫu',
      view: 'shared',
      name: 'Tour',
      type: 'tour',
      icon: 'fab fa-foursquare',
      apiEndpoints: [
        RESOURCE_ENDPOINTS.PLACE,
        RESOURCE_ENDPOINTS.PLACE_ENABLE,
        RESOURCE_ENDPOINTS.PLACE_LIST,
        RESOURCE_ENDPOINTS.PLACE_RATINGS,
        RESOURCE_ENDPOINTS.TOUR_DAY,
        RESOURCE_ENDPOINTS.TOUR_DAY_LIST,
        RESOURCE_ENDPOINTS.TOUR_DES,
        RESOURCE_ENDPOINTS.GROUP,
        RESOURCE_ENDPOINTS.GROUP_ITEM,
        RESOURCE_ENDPOINTS.PLACE_CATEGORIES,
        RESOURCE_ENDPOINTS.TAG,
        RESOURCE_ENDPOINTS.STORAGE,
        RESOURCE_ENDPOINTS.STORAGE_LIST
      ],
      index: {
        titles: [{ label: 'TOUR DU LỊCH MẪU', value: 'tour' }],
        columns: ['stt', 'avatar', 'name', 'organization', 'star', 'rating', 'view_count', 'created_at', 'updated_at', 'language', 'actions'],
        actions: ['showQR', 'public', 'private', 'edit', 'delete'],
        headerActions: ['add', 'filter', 'reset', 'synchronize', 'import', 'export'],
        excelColumns: ['id', 'name', 'ordered', 'qr_code', 'distance', 'description', 'content', 'agent_info', 'policy', 'tip_hour', 'status', 'country_id', 'area_id', 'category_id', 'tags', 'youtube_links']
      },
      show: {
        inputs: ['name', 'ordered', 'qr_code', 'distance', 'description', 'content', 'agent_info', 'policy', 'tip_hour'],
        leftCards: ['rating', 'schedule', 'groups'],
        rightCards: [
          // 'packages',//
          'display',
          'price',
          'place',
          'address',
          'contact',
          'category',
          'tags',
          'youtube',
          'audios',
          'documents',
          'pictures',
          'videos'
        ]
      }
    },
    {
      title: 'Tour du lịch thương mại',
      view: 'shared',
      name: 'Commerce',
      type: 'commerce',
      icon: 'fas fa-plane-departure',
      apiEndpoints: [
        RESOURCE_ENDPOINTS.PLACE,
        RESOURCE_ENDPOINTS.PLACE_ENABLE,
        RESOURCE_ENDPOINTS.PLACE_LIST,
        RESOURCE_ENDPOINTS.PLACE_RATINGS,
        RESOURCE_ENDPOINTS.TOUR_DAY,
        RESOURCE_ENDPOINTS.TOUR_DAY_LIST,
        RESOURCE_ENDPOINTS.TOUR_DES,
        RESOURCE_ENDPOINTS.GROUP,
        RESOURCE_ENDPOINTS.GROUP_ITEM,
        RESOURCE_ENDPOINTS.PLACE_CATEGORIES,
        RESOURCE_ENDPOINTS.TAG,
        RESOURCE_ENDPOINTS.STORAGE,
        RESOURCE_ENDPOINTS.STORAGE_LIST
      ],
      index: {
        titles: [{ label: 'TOUR DU LỊCH THƯƠNG MẠI', value: 'commerce' }],
        columns: ['stt', 'avatar', 'name', 'organization', 'star', 'rating', 'view_count', 'created_at', 'updated_at', 'language', 'actions'],
        actions: ['showQR', 'public', 'private', 'edit', 'delete'],
        headerActions: ['add', 'filter', 'reset', 'synchronize', 'import', 'export'],
        excelColumns: ['id', 'name', 'ordered', 'qr_code', 'distance', 'description', 'content', 'agent_info', 'policy', 'tip_hour', 'status', 'country_id', 'area_id', 'country_id', 'area_id', 'category_id', 'tags', 'youtube_links']
      },
      show: {
        inputs: ['name', 'ordered', 'qr_code', 'distance', 'description', 'content', 'agent_info', 'policy', 'tip_hour'],
        leftCards: ['rating', 'schedule', 'groups'],
        rightCards: [
          // 'packages',//
          'display',
          'price',
          'place',
          'address',
          'contact',
          'category',
          'tags',
          'youtube',
          'audios',
          'documents',
          'pictures',
          'videos'
        ]
      }
    },
    {
      title: 'Phương tiện vận tại',
      view: 'shared',
      name: 'Transportation',
      type: 'transportation',
      icon: 'fab fa-foursquare',
      apiEndpoints: [
        RESOURCE_ENDPOINTS.PLACE,
        RESOURCE_ENDPOINTS.PLACE_ENABLE,
        RESOURCE_ENDPOINTS.PLACE_LIST,
        RESOURCE_ENDPOINTS.PLACE_RATINGS,
        RESOURCE_ENDPOINTS.TOUR_DAY,
        RESOURCE_ENDPOINTS.TOUR_DAY_LIST,
        RESOURCE_ENDPOINTS.TOUR_DES,
        RESOURCE_ENDPOINTS.GROUP,
        RESOURCE_ENDPOINTS.GROUP_ITEM,
        RESOURCE_ENDPOINTS.PLACE_CATEGORIES,
        RESOURCE_ENDPOINTS.TAG,
        RESOURCE_ENDPOINTS.STORAGE,
        RESOURCE_ENDPOINTS.STORAGE_LIST
      ],
      index: {
        titles: [{ label: 'PHƯƠNG TIỆN VẬN TẢI', value: 'transportation' }],
        columns: ['stt', 'avatar', 'name', 'organization', 'star', 'rating', 'view_count', 'created_at', 'updated_at', 'language', 'actions'],
        actions: ['showQR', 'public', 'private', 'edit', 'delete'],
        headerActions: ['add', 'filter', 'reset', 'synchronize', 'import', 'export'],
        excelColumns: ['id', 'name', 'ordered', 'qr_code', 'distance', 'description', 'content', 'agent_info', 'policy', 'tip_hour', 'status', 'country_id', 'area_id', 'category_id', 'tags', 'youtube_links']
      },
      show: {
        inputs: ['name', 'ordered', 'qr_code', 'distance', 'description', 'content', 'agent_info', 'policy', 'tip_hour'],
        leftCards: ['rating', 'schedule', 'groups'],
        rightCards: [
          // 'packages',//
          'display',
          'price',
          'place',
          'address',
          'contact',
          'category',
          'tags',
          'youtube',
          'audios',
          'documents',
          'pictures',
          'videos'
        ]
      }
    },
    {
      title: 'Hướng dẫn viên',
      view: 'shared',
      name: 'Tour-guide',
      type: 'tour-guide',
      icon: 'fas fa-user-tie',
      apiEndpoints: [
        RESOURCE_ENDPOINTS.PLACE,
        RESOURCE_ENDPOINTS.PLACE_ENABLE,
        RESOURCE_ENDPOINTS.PLACE_LIST,
        RESOURCE_ENDPOINTS.PLACE_RELATED,
        RESOURCE_ENDPOINTS.PLACE_RATINGS,
        RESOURCE_ENDPOINTS.ARTIFACT,
        RESOURCE_ENDPOINTS.ARTIFACT_LIST,
        RESOURCE_ENDPOINTS.ARTIFACT_CLASSIFICATION,
        RESOURCE_ENDPOINTS.GROUP,
        RESOURCE_ENDPOINTS.GROUP_ITEM,
        RESOURCE_ENDPOINTS.STORAGE,
        RESOURCE_ENDPOINTS.STORAGE_LIST,
        RESOURCE_ENDPOINTS.PLACE_CATEGORIES,
        RESOURCE_ENDPOINTS.TAG
      ],
      index: {
        titles: [{ label: 'Hướng dẫn viên', value: 'people' }],
        columns: ['stt', 'avatar', 'name', 'parent', 'organization', 'star', 'rating', 'view_count', 'created_at', 'updated_at', 'language', 'actions'],
        actions: ['copy', 'showQR', 'public', 'private', 'edit', 'detail', 'related', 'booking', 'delete'],
        headerActions: ['add', 'filter', 'reset', 'synchronize', 'import', 'export'],
        excelColumns: ['id', 'name', 'ordered', 'qr_code', 'vrtour', 'vrtour_trailer', 'description', 'content', 'status', 'date_of_birth', 'date_of_death', 'location_address', 'location_longitude', 'location_latitude', 'country_id', 'area_id', 'contact_info_phone', 'contact_info_email', 'contact_info_website', 'facebook_url', 'zalo_url', 'category_id', 'tags', 'youtube_links']
      },
      show: {
        inputs: ['name', 'ordered', 'qr_code', 'vrtour', 'vrtour_trailer', 'description', 'content'],
        leftCards: ['rating', 'artifacts', 'artifact_groups', 'groups', 'background'],
        rightCards: [
          // 'packages',//
          'place_parent',
          'display',
          'date_of_birth',
          'address',
          'contact',
          'category',
          'tags',
          'youtube',
          'audios',
          'documents',
          'pictures',
          'videos'
        ]
      },
      detail: [
        'tour',
        'post'
      ],
      related: [
        'museum',
        'attraction',
        'event'
      ]
    },
    {
      title: 'Phân hệ',
      name: 'Hierarchy',
      type: 'hierarchy',
      icon: 'fas fa-sitemap',
      show: false,
      detail: true,
      apiEndpoints: [
        RESOURCE_ENDPOINTS.HIERARCHY,
        RESOURCE_ENDPOINTS.HIERARCHY_ITEM,
        RESOURCE_ENDPOINTS.STORAGE
      ]
    },
    {
      title: 'Bình luận',
      view: 'shared',
      name: 'Comment',
      type: 'comment',
      icon: 'fas fa-comment',
      apiEndpoints: [
        RESOURCE_ENDPOINTS.COMMENT,
        RESOURCE_ENDPOINTS.COMMENT_LIST
      ],
      index: {
        titles: [{ label: 'BÌNH LUẬN ĐÃ DUYỆT', value: 'true' }, { label: 'BÌNH LUẬN CHƯA DUYỆT', value: 'false' }],
        columns: ['stt', 'c_object', 'c_creator', 'content', 'c_approved', 'c_created_at', 'actions'],
        actions: ['browser', 'unbrowser', 'delete'],
        headerActions: ['reset', 'export'],
        excelColumns: ['id', 'object', 'creator', 'content', 'approved']
      }
    },
    {
      title: 'Trang Banner',
      name: 'Pages',
      type: 'pages',
      icon: 'fas fa-ad',
      show: false,
      apiEndpoints: [
        RESOURCE_ENDPOINTS.BANNERS,
        RESOURCE_ENDPOINTS.DISPLAY_MODELS
      ]
    },
    {
      title: 'Danh sách yêu thích',
      name: 'Boards',
      type: 'boards',
      icon: 'fas fa-thumbs-up',
      show: false,
      detail: true,
      apiEndpoints: [
        RESOURCE_ENDPOINTS.BOARDS,
        RESOURCE_ENDPOINTS.BOARD_ITEMS,
        RESOURCE_ENDPOINTS.TAG
      ]
    },
    {
      title: 'Danh mục',
      name: 'Category',
      type: 'category',
      icon: 'fas fa-folder',
      show: false,
      apiEndpoints: [
        RESOURCE_ENDPOINTS.PLACE_CATEGORIES
      ],
      index: {
        excelColumns: ['id', 'name']
      }
    },
    {
      title: 'Thẻ Tag',
      name: 'Tags',
      type: 'tags',
      icon: 'fas fa-tag',
      show: false,
      apiEndpoints: [
        RESOURCE_ENDPOINTS.TAG
      ],
      index: {
        excelColumns: ['id', 'name', 'description']
      }
    },
    {
      title: 'Package',
      name: 'Package',
      type: 'package',
      icon: 'fas fa-box',
      show: false,
      apiEndpoints: [
        RESOURCE_ENDPOINTS.PACKAGE,
        RESOURCE_ENDPOINTS.PACKAGE_PLACE
      ]
    },
    {
      title: 'Phòng ban',
      name: 'Department',
      type: 'department',
      icon: 'fas fa-laptop-house',
      show: false,
      apiEndpoints: [
        RESOURCE_ENDPOINTS.DEPARTMENT
      ]
    },
    {
      title: 'Nơi làm việc',
      name: 'WorkingLocation',
      type: 'working-location',
      icon: 'fas fa-place-of-worship',
      show: false,
      apiEndpoints: [
        RESOURCE_ENDPOINTS.WORKING_LOCATION
      ]
    },
    {
      title: 'Dịch vụ',
      name: 'PlaceServices',
      type: 'place-services',
      icon: 'fas fa-concierge-bell',
      apiEndpoints: [
        RESOURCE_ENDPOINTS.PLACE_SERVICES,
        RESOURCE_ENDPOINTS.STORAGE
      ],
      show: false,
      index: {
        excelColumns: ['id', 'name']
      }
    },
    {
      title: 'Tiện ích',
      name: 'PlaceFacilities',
      type: 'place-facilities',
      icon: 'fas fa-bath',
      apiEndpoints: [
        RESOURCE_ENDPOINTS.PLACE_FACILITIES,
        RESOURCE_ENDPOINTS.STORAGE
      ],
      show: false,
      index: {
        excelColumns: ['id', 'name']
      }
    },
    {
      title: 'Nhóm tiện ích',
      name: 'PlaceFacilityGroups',
      type: 'place-facility-groups',
      icon: 'fas fa-layer-group',
      apiEndpoints: [
        RESOURCE_ENDPOINTS.PLACE_FACILITY_GROUPS
      ],
      show: false,
      index: {
        excelColumns: ['id', 'name']
      }
    },
    {
      title: 'Rating',
      name: 'PlaceRating',
      type: 'place-rating',
      icon: 'fas fa-star',
      apiEndpoints: [
        RESOURCE_ENDPOINTS.PLACE_RATINGS,
        RESOURCE_ENDPOINTS.PLACE,
        RESOURCE_ENDPOINTS.PLACE_ENABLE,
        RESOURCE_ENDPOINTS.PLACE_LIST
      ],
      show: false,
      index: {
        excelColumns: ['id', 'place_id', 'origin', 'external_id', 'rating', 'author_name', 'rated_at']
      }
    },
    {
      title: 'Danh sách',
      name: 'Artifacts',
      type: 'artifacts',
      icon: 'fas fa-list',
      show: false,
      apiEndpoints: [
        RESOURCE_ENDPOINTS.ARTIFACT,
        RESOURCE_ENDPOINTS.ARTIFACT_LIST,
        RESOURCE_ENDPOINTS.ARTIFACT_CLASSIFICATION
      ],
      index: {
        excelColumns: ['id', 'place_id', 'name', 'ordered', 'vrtour', 'description', 'content']
      }
    },
    {
      title: 'Lịch trình',
      name: 'TourDays',
      type: 'tour-days',
      icon: 'fas fa-calendar',
      show: false,
      apiEndpoints: [
        RESOURCE_ENDPOINTS.TOUR_DAY,
        RESOURCE_ENDPOINTS.TOUR_DAY_LIST,
        RESOURCE_ENDPOINTS.TOUR_DES,
        RESOURCE_ENDPOINTS.TOUR_DES_LIST
      ],
      index: {
        excelColumns: ['id', 'place_id', 'time', 'distance', 'description']
      }
    },
    {
      title: 'Hạng phòng',
      name: 'Room-types',
      type: 'room-types',
      icon: 'fas fa-hotel',
      show: false,
      apiEndpoints: [
        RESOURCE_ENDPOINTS.ROOM_TYPE,
        RESOURCE_ENDPOINTS.ROOM_TYPE_LIST
      ],
      index: {
        excelColumns: ['id', 'place_id', 'name', 'bed_info', 'acreage', 'facilities', 'vrtour', 'description', 'content']
      }
    },
    {
      title: 'Quản trị viên',
      name: 'Staff',
      type: 'staff',
      icon: 'fas fa-id-badge',
      apiEndpoints: [
        RESOURCE_ENDPOINTS.USER,
        RESOURCE_ENDPOINTS.USER_LIST,
        RESOURCE_ENDPOINTS.USER_RESET_PASSWORD,
        RESOURCE_ENDPOINTS.DEPARTMENT,
        RESOURCE_ENDPOINTS.WORKING_LOCATION,
        RESOURCE_ENDPOINTS.STORAGE
      ],
      show: false
    },
    {
      title: 'Người dùng',
      name: 'User',
      type: 'user',
      icon: 'fas fa-users',
      show: false,
      apiEndpoints: [
        RESOURCE_ENDPOINTS.USER,
        RESOURCE_ENDPOINTS.USER_LIST,
        RESOURCE_ENDPOINTS.USER_RESET_PASSWORD,
        RESOURCE_ENDPOINTS.DEPARTMENT,
        RESOURCE_ENDPOINTS.WORKING_LOCATION,
        RESOURCE_ENDPOINTS.STORAGE
      ]
    },
    {
      title: 'Hỗ trợ',
      name: 'Support',
      type: 'support',
      icon: 'fas fa-headset',
      show: false,
      apiEndpoints: [
        RESOURCE_ENDPOINTS.USER_REGISTER_FORMS
      ]
    },
    {
      title: 'Media',
      name: 'Media',
      type: 'media',
      icon: 'fas fa-photo-video',
      show: false,
      apiEndpoints: [
        RESOURCE_ENDPOINTS.STORAGE,
        RESOURCE_ENDPOINTS.STORAGE_LIST,
        RESOURCE_ENDPOINTS.STORAGE_CHANGE_ORDER,
        RESOURCE_ENDPOINTS.STORAGE_URL
      ]
    }
  ]
}
